<template>
  <div class="jim-scheduling-container">
    
    <div class="page-header-row">
      <div class="page-header-left">
        
      </div>

      <h1 class="page-heading">PRODUCTION SCHEDULING</h1>

     <div class="page-header-right">
        <div
          class="connection-pill"
          :class="connectionHealth.overallStatus === 'healthy' ? 'connection-good' : 'connection-bad'"
          :title="connectionHealth.userMessage"
          @click="checkConnectionHealth"
        >
          <span class="connection-dot"></span>
          <span class="connection-text">
            {{ connectionHealth.overallStatus === 'healthy' ? 'Connected' : 'Connection Issue' }}
          </span>
        </div>
      </div>
    </div> 

        
      

    <div class="main-content">
      <!-- Left side section for Location dropdown and Resources -->
      <div class="left-side-section">

        <!-- Planning Window -->
        <div
          class="planning-window"
          style="margin-bottom: 0.75rem;"
        >
          <label for="planningDays" style="margin-right: 0.5rem;">
            Planning Days:
          </label>
          <select v-model="planningDays" id="planningDays">
            <option v-for="n in 7" :key="n" :value="n">{{ n }}</option>
          </select>
        </div>

        <button
          class="plan-it-btn"
          @click="runFeatureEngFG('refresh-button')"
          :disabled="isPlanning || isRefreshing"
          style="margin-left: 0.75rem;"
        >
          {{ isRefreshing ? 'Refreshing…' : 'Refresh' }}
        </button>

        <button
          class="plan-it-btn"
          @click="planItPablo"
          disabled
        >
          {{ isPlanning ? 'Planning…' : 'Plan It Pablo' }}
        </button>

        <button class="plan-it-btn" @click="showPendingModal = true">
          Pending Orders
        </button>

        <button class="plan-it-btn" @click="openCreateWoModal">
          Create Work Order
        </button>

        <button class="plan-it-btn" @click="openPrintTab">
          Print Schedule
        </button>

        <button class="plan-it-btn" @click="openExcelTab">
          Export Excel
        </button>

        <button class="plan-it-btn" @click="openOperatorSnapshotPrint">
          Operator Snapshot Print
        </button>

        <button class="plan-it-btn" @click="openOperatorSnapshotExcel">
          Operator Snapshot Excel
        </button>


        <!--add to JPL Live-->

        <button class="plan-it-btn pablotify-btn" @click="$refs.pablotify.openPopup()">
          Comm Center
          <span v-if="pablotifyUnread > 0" class="notif-badge">
            🔔 {{ pablotifyUnread }}
          </span>
        </button>

        <button class="plan-it-btn" @click="openPlanNotesModal">
          Plan Notes
        </button>

        <PabloQuacious
          ref="pablotify"
          :dept="'Production'"
          :loc="selectedLocation"
          :showButton="false"
          @unread-count="pablotifyUnread = $event"
        />
      <!--end add to JPL Live-->

        
        
      </div>
      
      <!-- Modal/popup with PendingWorkOrders -->
      <div v-if="showPendingModal" class="popup-overlay">
        <div class="pending-popup-content">
          <PendingWorkOrders
            :initialLocation="selectedLocation"
            @close="showPendingModal = false"
            @committed="handlePendingOrdersCommitted"
          />
        </div>
      </div>



      
      <div class="machines-section">
        <div class="stacked-machines">
          <!-- MachinesView emits the mark-resource-dropped event, handled by markResourceDropped method -->
          <MachinesView
            :machines="filteredMachines"
            :throughput="throughput"
            :planningDays="planningDays"
            @update-schedule="updateSchedule"
            @show-insufficiency-details="showInsufficiencyDetails"
            @show-forecast-details="showForecastDetails"
            :materialAlerts="materialAlerts"
            @mark-resource-dropped="markResourceDropped"
            :unscheduledForecasts="unscheduledForecasts"
            :selectedLocation="selectedLocation"
            @show-day-demand="openDayDemandModal"
            :machineNotes="machineNotes"
            @open-machine-notes="openMachineNotesModal"
            :machineItemLimits="machineItemLimits"
            @update-machine-item-limit="onUpdateMachineItemLimit"
            @show-machine-load="openMachineLoadModal"
            :showMachineLoadModal="showMachineLoadModal"
            :selectedMachineLoad="selectedMachineLoad"
            @close-machine-load-modal="closeMachineLoadModal"
            @run-plan-move="handleRunPlanMove"
            @run-plan-set="handleRunPlanSet"
            @open-machine-resources="openMachineResourcesModal"
            @lock-machine="lockMachine"
            @unlock-machine="unlockMachine"
            @toggle-machine-lock="toggleMachineLock"
            @fill-machine-runs="fillMachineRuns"
            @open-machine-hours-maintenance="openMachineHoursMaintenance"
            @schedule-resequenced="fetchCurrentSchedule"
            @schedule-resequence-failed="fetchCurrentSchedule"
            @set-keep-manual-sequence="setKeepManualSequence"
            @set-work-order-execution-flags="setWorkOrderExecutionFlags"




          />
        </div>
      </div>



      <div class="unscheduled-section">       
      <UnscheduledView
        :unscheduledOrders="combinedUnscheduledOrders"
        :sales-plus-sort-mode="salesPlusSortMode"
        @sales-plus-sort-change="handleSalesPlusSortChange"
        @update-unscheduled="updateUnscheduled"
        @move-to-machine="moveToMachine"
        @move-to-trash="moveToTrash"
      />
      </div>
    </div>

    <!-- <button @click="saveSchedule">Save</button> -->

    <VoiceAssistant @show-old-work-orders="displayOldWorkOrders" />
    <div v-if="oldWorkOrders.length">
      <h2>Old Work Orders</h2>
      <ul>
        <li v-for="order in oldWorkOrders" :key="order.ord_no">
          {{ order }}
        </li>
      </ul>
    </div>

    <TrashCan :orders="trashOrders" @restore-order="restoreOrder" />

<!-- Popup for insufficiency details -->
<div v-if="showPopup" class="popup-overlay">
  <div class="popup-content">
    <div class="popup-header">
      <h3>Insufficiency Details</h3>

      <button
        class="close-btn"
        @click="closePopup"
      >
        ✕
      </button>
    </div>

    <table class="popup-table">
      <thead>
        <tr>
          <th>Type</th>
          <th>Component</th>
          <th>Quantity On Hand</th>
          <th>Quantity Short</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(detail, index) in insufficiencyDetails"
          :key="
            detail.component_item_no ||
            detail.item_no_bom ||
            index
          "
        >
          <td>
            {{
              detail.shortage_label ||
              detail.component_type ||
              'Material'
            }}
          </td>

          <td>
            {{
              detail.component_item_no ||
              detail.item_no_bom ||
              ''
            }}
          </td>

          <td>
            {{ formatQty(detail.qty_on_hand) }}
          </td>

          <td>
            {{
              formatQty(
                detail.cumulative_shortage ??
                detail.shortage
              )
            }}
          </td>
        </tr>
      </tbody>
    </table>

    <div
      v-if="!insufficiencyDetails.length"
      style="margin-top: 0.75rem;"
    >
      <em>No insufficiencies found for this work order.</em>
    </div>
  </div>
</div>

<!-- 🛠 Machine Hours Maintenance Modal -->
<div
  v-if="showMachineHoursModal && selectedMachineHours"
  class="shortage-modal-backdrop"
>
  <div class="shortage-modal machine-hours-modal">
    <div class="shortage-modal-header">
      <h3>
        Machine Input Hours – {{ selectedMachineHours.machine }}
      </h3>

      <button class="close-btn" @click="closeMachineHoursMaintenance">
        ✕
      </button>
    </div>

    <div class="shortage-modal-body">
      <p>
        <strong>Location:</strong> {{ selectedMachineHours.loc }}<br />
        <strong>Machine:</strong> {{ selectedMachineHours.machine }}
      </p>

      <div v-if="machineHoursLoading">
        <em>Loading machine hours…</em>
      </div>

      <div v-else>
        <label class="machine-hours-label">
          Allowed Hours
        </label>

        <input
          class="machine-hours-input"
          type="number"
          step="0.25"
          min="0"
          v-model="selectedMachineHours.allowed_hours"
        />

        <div
          v-if="machineHoursError"
          class="machine-hours-error"
        >
          {{ machineHoursError }}
        </div>

        <div
          v-if="machineHoursSuccess"
          class="machine-hours-success"
        >
          {{ machineHoursSuccess }}
        </div>

        <div class="machine-hours-actions">
          <button
            class="notes-btn"
            @click="saveMachineHours"
            :disabled="machineHoursSaving"
          >
            {{ machineHoursSaving ? "Saving…" : "Save" }}
          </button>

          <button
            class="notes-btn"
            @click="closeMachineHoursMaintenance"
            :disabled="machineHoursSaving"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 👷 Machine Resources Modal -->
<div
  v-if="showMachineResourcesModal && selectedResourcesMachine"
  class="shortage-modal-backdrop"
>
  <div class="shortage-modal">
    <div class="shortage-modal-header">
      <h3>Resources – {{ selectedResourcesMachine.name }}</h3>
      <button class="close-btn" @click="closeMachineResourcesModal">✕</button>
    </div>

    <div class="shortage-modal-body">
      <div class="notes-section">
        <label><strong>Operator</strong></label>
        <select
          class="wo-status-select"
          v-model.number="selectedOperatorResourceId"
        >
          <option :value="null">—</option>
          <option
            v-for="r in eligibleOperators"
            :key="r.resource_id"
            :value="r.resource_id"
          >
            {{ r.employee_name }}
          </option>
        </select>
      </div>

      <hr />

      <div class="notes-section">
        <label><strong>Boxer</strong></label>
        <select
          class="wo-status-select"
          v-model.number="selectedBoxerResourceId"
        >
          <option :value="null">—</option>
          <option
            v-for="r in eligibleBoxers"
            :key="r.resource_id"
            :value="r.resource_id"
          >
            {{ r.employee_name }}
          </option>
        </select>
      </div>

      <hr />

      <div class="notes-section">
        <div style="display:flex; gap:10px; justify-content:flex-end;">
          <button class="notes-btn" @click="closeMachineResourcesModal">Cancel</button>
          <button class="notes-btn" @click="saveMachineResources">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- 📝 Machine Notes Modal -->
<div
  v-if="showMachineNotesModal && selectedNotesMachine"
  class="shortage-modal-backdrop"
>
  <div class="shortage-modal machine-notes-modal">
    <div class="shortage-modal-header">
      <h3>Notes & Shortages – {{ selectedNotesMachine.name }}</h3>
      <button class="close-btn" @click="closeMachineNotesModal">✕</button>
    </div>

    <div class="shortage-modal-body">
      <!-- Machine-level note -->
      <div class="notes-section">
        
        <textarea
          class="notes-textarea"
          v-model="machineNoteDraft"
          placeholder="Type machine note..."
        ></textarea>
      </div>

      <hr />

      <!-- Work orders on this machine -->
      <div class="notes-section">
        <label><strong>Work orders</strong></label>

        <div v-if="!selectedNotesMachine.orders || !selectedNotesMachine.orders.length">
          <em>No work orders found for this machine.</em>
        </div>

        <div v-else class="machine-notes-table-wrap">
          <table class="shortage-table machine-notes-table">
            <thead>
              <tr>
                <th class="shortage-toggle-heading"></th>
                <th>WO #</th>
                <th>Item</th>
                <th>Qty</th>
                <th>Status</th>
                <th>Note 1</th>
                <th>Note 2</th>
              </tr>
            </thead>

            <tbody>
              <template
                v-for="(wo, idx) in selectedNotesMachine.orders"
                :key="getWoRowKey(wo, idx)"
              >
                <!-- Main work-order row -->
                <tr class="machine-note-main-row">
                  <td class="shortage-toggle-cell">
                    <button
                      v-if="hasWoShortages(wo)"
                      type="button"
                      class="shortage-expand-btn"
                      :title="
                        isWoShortageExpanded(wo, idx)
                          ? 'Hide shortage details'
                          : 'Show shortage details'
                      "
                      @click.stop="toggleWoShortageRow(wo, idx)"
                    >
                      {{ isWoShortageExpanded(wo, idx) ? '−' : '+' }}
                    </button>

                    <span
                      v-else
                      class="no-shortage-symbol"
                      title="No material shortages"
                    >
                      —
                    </span>
                  </td>

                  <td>{{ wo.orderId ?? wo.ord_no }}</td>

                  <td>
                    <div>
                      {{ wo.partNumber ?? wo.item_no }}
                    </div>

                    <div
                      v-if="wo.standing_note"
                      class="standing-note-inline"
                    >
                      
                      {{ wo.standing_note }}
                    </div>
                  </td>

                  <td>
                    {{ Math.round(Number(wo.ord_qty || 0)).toLocaleString() }}
                  </td>

                  <td>
                    <select
                      class="wo-status-select"
                      v-model="wo.wo_status"
                      @change="queueAutosaveWoNotes(wo)"
                    >
                      <option value="">—</option>

                      <option
                        v-for="s in workOrderStatuses"
                        :key="s.status_code"
                        :value="s.status_code"
                      >
                        {{ s.display_name }}
                      </option>
                    </select>
                  </td>

                  <td>
                    <input
                      class="wo-note-input"
                      v-model="wo.wo_note_1"
                      @input="queueAutosaveWoNotes(wo)"
                    />
                  </td>

                  <td>
                    <input
                      class="wo-note-input"
                      v-model="wo.wo_note_2"
                      @input="queueAutosaveWoNotes(wo)"
                    />
                  </td>
                </tr>

                <!-- Expandable nested shortage row -->
                <tr
                  v-if="
                    hasWoShortages(wo) &&
                    isWoShortageExpanded(wo, idx)
                  "
                  class="nested-shortage-row"
                >
                  <td colspan="7">
                    <div class="nested-shortage-panel">
                      <div class="nested-shortage-heading">
                        Shortage details for
                        <strong>{{ getWoItemNo(wo) }}</strong>
                      </div>

                      <div
                        v-if="shortageLoadingByItem[getWoItemNo(wo)]"
                        class="nested-shortage-message"
                      >
                        Loading shortage details…
                      </div>

                      <div
                        v-else-if="shortageErrorByItem[getWoItemNo(wo)]"
                        class="nested-shortage-error"
                      >
                        {{ shortageErrorByItem[getWoItemNo(wo)] }}
                      </div>

                      <table
                        v-else-if="getWoShortageDetails(wo).length"
                        class="nested-shortage-table"
                      >
                        <thead>
                          <tr>
                            <th>Type</th>
                            <th>Component</th>
                            <th>Qty Needed</th>
                            <th>Quantity On Hand</th>
                            <th>Quantity Short</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            v-for="(detail, detailIndex) in getWoShortageDetails(wo)"
                            :key="
                              detail.component_item_no ||
                              `${getWoItemNo(wo)}-${detailIndex}`
                            "
                          >
                            <td>
                              {{
                                detail.shortage_label ||
                                detail.component_type ||
                                'Material'
                              }}
                            </td>

                            <td>
                              {{ detail.component_item_no }}
                            </td>

                            <td>
                              {{ formatQty(detail.qty_needed) }}
                            </td>

                            <td>
                              {{ formatQty(detail.qty_on_hand) }}
                            </td>

                            <td class="nested-shortage-quantity">
                              {{
                                formatQty(
                                  detail.cumulative_shortage ??
                                  detail.shortage
                                )
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <div
                        v-else
                        class="nested-shortage-message"
                      >
                        No current shortage-detail rows were returned for this item.
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- ➕ Popup for Create Work Order -->
<div v-if="showCreateWoModal" class="shortage-modal-backdrop">
  <div class="shortage-modal">
    <div class="shortage-modal-header">
      <h3>Create Work Order</h3>
      <button class="close-btn" @click="closeCreateWoModal">✕</button>
    </div>

    <div class="shortage-modal-body">
      <p style="margin-top:0;">
        <strong>Location:</strong> {{ selectedLocation }}
      </p>

      <div style="display:grid; grid-template-columns:1fr 1fr; gap:10px;">
        <div>
          <label><strong>Machine</strong></label>
          <select v-model="createWoForm.machine" class="shortage-input">
            <option value="" disabled>
              {{ createWoOptions.loadingMachines ? 'Loading machines…' : 'Select machine' }}
            </option>
            <option v-for="m in createWoOptions.machines" :key="m" :value="m">
              {{ m }}
            </option>
          </select>
        </div>

        <div>
          <label><strong>Item</strong></label>
          <select
            v-model="createWoForm.partNumber"
            class="shortage-input"
            :disabled="!createWoForm.machine || createWoOptions.loadingItems"
          >
            <option value="" disabled>
              <span v-if="!createWoForm.machine">Select machine first</span>
              <span v-else-if="createWoOptions.loadingItems">Loading items…</span>
              <span v-else>Select item</span>
            </option>

            <option v-for="it in createWoOptions.items" :key="it" :value="it">
              {{ it }}
            </option>
          </select>
        </div>

        <div>
          <label><strong>Order Qty</strong></label>
          <input v-model.number="createWoForm.ord_qty" type="number" min="1" class="shortage-input" />
        </div>

        
      </div>

      <div v-if="createWoUi.error" style="margin-top:10px;">
        <em style="color:#b00020;">{{ createWoUi.error }}</em>
      </div>

      <div style="display:flex; gap:10px; margin-top:14px; justify-content:flex-end;">
        <button class="plan-it-btn" @click="closeCreateWoModal" :disabled="createWoUi.loading">
          Cancel
        </button>
        <button class="plan-it-btn" @click="submitCreateWorkOrder" :disabled="createWoUi.loading">
          {{ createWoUi.loading ? 'Creating…' : 'Create' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- 📝 Plant Plan Notes Modal -->
<div v-if="showPlanNotesModal" class="shortage-modal-backdrop">
  <div class="shortage-modal">
    <div class="shortage-modal-header">
      <h3>Plan Notes – Loc {{ selectedLocation }}</h3>
      <button class="close-btn" @click="closePlanNotesModal">✕</button>
    </div>

    <div class="shortage-modal-body">
      <p class="small-muted" style="margin-top:0;">
        These notes print on the Operator Snapshot and are shared across the plant for the selected location.
      </p>

      <div class="notes-section">
        <label><strong>Day Shift</strong></label>
        <textarea
          class="notes-textarea plan-notes-textarea"
          v-model="planNotes.Day"
          placeholder="Enter Day Shift priorities..."
        ></textarea>
      </div>

      <hr />

      <div class="notes-section">
        <label><strong>Swing Shift</strong></label>
        <textarea
          class="notes-textarea plan-notes-textarea"
          v-model="planNotes.Swing"
          placeholder="Enter Swing Shift priorities..."
        ></textarea>
      </div>

      <hr />

      <div class="notes-section">
        <label><strong>Graveyard Shift</strong></label>
        <textarea
          class="notes-textarea plan-notes-textarea"
          v-model="planNotes.Graveyard"
          placeholder="Enter Graveyard Shift priorities..."
        ></textarea>
      </div>

      <div v-if="planNotesSaving" style="margin-top:10px;">
        <em>Saving plan notes…</em>
      </div>

      <div style="display:flex; gap:10px; justify-content:flex-end; margin-top:14px;">
        <button class="notes-btn" @click="closePlanNotesModal" :disabled="planNotesSaving">
          Cancel
        </button>

        <button class="notes-btn" @click="savePlanNotes" :disabled="planNotesSaving">
          {{ planNotesSaving ? "Saving…" : "Save" }}
        </button>
      </div>
    </div>
  </div>
</div>

   
<!-- ➕ Popup for forecast-driven items -->
<div v-if="showForecastPopup" class="popup-overlay">
  <div class="popup-content">
    <div class="popup-header">
      <h3>Forecast-Driven Production</h3>
      <button class="close-btn" @click="closeForecastPopup">✕</button>
    </div>

    <table class="popup-table">
      <tbody>
        <tr>
          <th style="width: 180px;">Item</th>
          <td>{{ forecastDetails.item_no }}</td>
        </tr>
        <tr>
          <th>Quantity</th>
          <td>{{ forecastDetails.ord_qty }}</td>
        </tr>
        <tr>
          <th>Source</th>
          <td>{{ forecastDetails.source }}</td>
        </tr>
      </tbody>
    </table>

    <div v-if="!forecastDetails || !forecastDetails.item_no" style="margin-top: 0.75rem;">
      <em>No forecast-driven production found.</em>
    </div>
  </div>
</div>

    <div v-if="showDayDemandModal && selectedDayDemand" class="popup-overlay">
  <div class="pending-popup-content" style="text-align:left; width:min(900px, 96vw);">
    <div class="shortage-modal-header">
      <h3>Sales Demand – D {{ selectedDayDemand.dayIndex }}</h3>
      <button class="close-btn" @click="closeDayDemandModal">✕</button>
    </div>

    <div v-if="selectedDayDemand.loading">
      <em>Loading…</em>
    </div>

    <div v-else>
      <p>
        <strong>Item:</strong> {{ selectedDayDemand.order.partNumber }}<br />
        <strong>WO Qty (this day):</strong>
        {{ selectedDayDemand.order['D ' + selectedDayDemand.dayIndex] ?? 0 }}<br />
        <strong>Total SO Demand (this day):</strong> {{ selectedDayDemand.total_qty }}<br />
        <strong>SO Lines:</strong> {{ selectedDayDemand.line_count }}
      </p>

      <!-- ✅ Move-out reason selection -->
      <div class="controls-wrap" style="justify-content:flex-start; margin: 12px 0;">
        <div class="control" style="max-width:260px;">
          <label>Reason</label>
          <select v-model="moveOutReasonCode">
            <option value="RM_SHORTAGE">RM Shortage</option>
            <option value="MACHINE_DOWN">Machine Down</option>
            <option value="CAPACITY">Capacity / Overloaded</option>
            <option value="QUALITY_HOLD">Quality Hold</option>
          </select>
        </div>
      </div>

      <div v-if="moveOutReqError" class="small-muted" style="color:#ff5c5c; margin-top:6px;">
        {{ moveOutReqError }}
      </div>

      <div v-if="moveOutReqSuccess" class="small-muted" style="color:#56d364; margin-top:6px;">
        {{ moveOutReqSuccess }}
      </div>


      <div v-if="selectedDayDemand.error">
        <em>{{ selectedDayDemand.error }}</em>
      </div>

      <div v-else-if="!selectedDayDemand.rows.length">
        <em>No sales orders in this planning day for this item.</em>
      </div>

      <table v-else class="shortage-table">
        <thead>
          <tr>
            <th>SO #</th>
            <th>Customer</th>
            <th>City</th>
            <th>Req Ship</th>
            <th>Qty</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(r, idx) in selectedDayDemand.rows" :key="idx">
            <td>{{ r.ord_no }}</td>
            <td>{{ r.customer_name || ('Customer #' + r.customer_id) }}</td>
            <td>{{ r.customer_city || '' }}</td>
            <td>{{ formatDate(r.req_ship_dt) }}</td>
            <td>{{ r.qty_ordered }}</td>

            <td>
              <button
                class="plan-it-btn"
                @click.stop="sendMoveOutRequest(r)"
                :disabled="sendingMoveOutReq"
              >
                {{ sendingMoveOutReq ? "Sending…" : "Move Out" }}
              </button>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</div>



    <!-- Popup for Pablo Plan It completion -->
    <div v-if="showPlanItPopup" class="popup-overlay">
      <div class="popup-content">
        <h3>Pablo has planned it!</h3>
        <p>Refresh your browser to see the updates.</p>
        <button @click="closePlanItPopup">Okay</button>
      </div>
    </div>
    <PabloChatSidebar
      :loc="selectedLocation"
      :planningDays="planningDays"
    />

  </div>
</template>

<script>
import MachinesView from './MachinesView.vue';
import UnscheduledView from './UnscheduledView.vue';
import VoiceAssistant from './VoiceAssistant.vue';
import TrashCan from './TrashCan.vue';
import axios from 'axios';
import PendingWorkOrders from './PendingWorkOrders.vue';
import PabloChatSidebar from './PabloChatSidebar.vue';
import PabloQuacious from './PabloQuacious.vue';


export default {
  components: { MachinesView, UnscheduledView, VoiceAssistant, TrashCan, PendingWorkOrders, PabloChatSidebar, PabloQuacious }, // Added ResourcesView
  
  data() {
    return {
      machines: [],
      unscheduledOrders: [],
      outsideWindowOrders: [],
      salesPlusSortMode: 'DATE_PART',
      // Prevent an older toggle request from overwriting
      // a newer Sales+ response.
      salesPlusFetchSeq: 0,
      trashOrders: [],
      throughput: {},
      productionSchedule: [],
      oldWorkOrders: [],
      materialAlerts: [],
      insufficiencyDetails: [],
      // Shortage details used inside the Machine Notes modal
      insufficiencyDetailsByItem: {},
      expandedShortageRows: {},
      shortageLoadingByItem: {},
      shortageErrorByItem: {},
      unscheduledForecasts: [],
      forecastDetails: {},
      showForecastPopup: false,
      planningDays: 7,
      showPopup: false,
      trashedItems: [],
      showPendingModal: false,
      showPlanItPopup: false,
      showDayDemandModal: false,
      selectedDayDemand: null,
      machineNotes: [],
      showMachineNotesModal: false,
      selectedNotesMachine: null,
      machineNoteDraft: "",
      machineSaveTimer: null,
      machineNoteSaving: false,
      woSaveTimers: {},   
      woSaving: {},
      workOrderStatuses: [],
      isPlanning: false,
      refreshTimer: null,
      isRefreshing: false,
      machineItemLimits: {},
      showMachineLoadModal: false,
      selectedMachineLoad: null,
      showCreateWoModal: false,
      showMachineResourcesModal: false,
      selectedResourcesMachine: null,
      resourcesList: [],
      selectedOperatorResourceId: null,
      selectedBoxerResourceId: null,
      moveOutReasonCode: "CAPACITY",
      sendingMoveOutReq: false,
      moveOutReqError: "",
      moveOutReqSuccess: "",
      lockedMachines: {},

      showPlanNotesModal: false,
      planNotesSaving: false,
      planNotes: {
        Day: "",
        Swing: "",
        Graveyard: ""
      },
      
      connectionHealth: {
        overallStatus: 'unknown',
        userMessage: 'Checking Pablo connections...',
        macola: {
          connected: false,
          message: 'Checking Macola...'
        },
        magic: {
          connected: false,
          message: 'Checking Magic...'
        }
      },
  

      createWoForm: {
        machine: '',
        partNumber: '',
        ord_qty: null,
        ord_status: 'P'
      },

      createWoUi: {
        loading: false,
        error: ''
      },

      createWoOptions: {
        machines: [],
        items: [],
        loadingMachines: false,
        loadingItems: false
      },

      showMachineHoursModal: false,
      selectedMachineHours: null,
      machineHoursLoading: false,
      machineHoursSaving: false,
      machineHoursError: "",
      machineHoursSuccess: "",

  
      
    };
  },
  computed: {
    filteredMachines() {
      return this.machines.filter(machine => machine && machine.id);
    },
    selectedLocation() {
      return this.$root.selectedLocation; // Get selected location from App.vue
    },

    combinedUnscheduledOrders() {
      return [
        ...(this.unscheduledOrders || []),
        ...(this.outsideWindowOrders || [])
      ];
    },

    eligibleOperators() {
      return (this.resourcesList || []).filter(r => r.active && (r.role === 'operator' || r.role === 'both'));
    },
    eligibleBoxers() {
      return (this.resourcesList || []).filter(r => r.active && (r.role === 'boxer' || r.role === 'both'));
    },
    currentMachineNote() {
      if (!this.selectedNotesMachine) return '';

      const name = this.normalizeMachineName(this.selectedNotesMachine.name);
      const row = this.machineNotes.find(n =>
        this.normalizeMachineName(n.machine) === name
      );

      return row ? row.note_text : '';
    }

},

watch: {
  machineNoteDraft(newVal) {
    if (!this.showMachineNotesModal || !this.selectedNotesMachine) return;

    clearTimeout(this.machineSaveTimer);
    this.machineSaveTimer = setTimeout(() => {
      this.autoSaveMachineNote(newVal);
    }, 600); // debounce ms
  },

  'createWoForm.machine': function () {
    // clear any previous error when user changes selection
    this.createWoUi.error = '';
    this.fetchCreateWoItemsForMachine();
  },

  selectedLocation() {
    console.log("📍 Location changed → reloading machines:", this.selectedLocation);

    this.fetchMachines();          // ✅ THIS is missing right now
    this.fetchMachineNotes();
    this.fetchPlanNotes();

    // prevent confusing carry-over while new loc loads
    this.clearMachineResourcesInUi();
    this.fetchMachineResources();
  },

  
  planningDays(newVal, oldVal) {
    if (newVal === oldVal) return;

    clearTimeout(this.refreshTimer);
    this.refreshTimer = setTimeout(() => {
      this.refreshEngineAndReload('planningDays-change');
    }, 400);
  }


},

 
  methods: {
    moveToMachine(movedOrder) {
      console.log('moveToMachine method triggered with:', movedOrder);
      console.log('Move to Machine:', movedOrder);

      const machineIndex = this.machines.findIndex(m => m.id === movedOrder.toMachine);
      console.log('Target machine index:', machineIndex, 'Machine ID:', movedOrder.toMachine);

      if (machineIndex !== -1) {
        const orderToMove = this.unscheduledOrders.find(order => order.partNumber === movedOrder.partNumber) || movedOrder;
        console.log('Order to move:', orderToMove);

        let ord_qty = !isNaN(orderToMove.ord_qty) ? Number(orderToMove.ord_qty) : 1;
        console.log('orderToMove.ord_qty:', orderToMove.ord_qty, 'Type:', typeof orderToMove.ord_qty);
        console.log('Final ord_qty to be used:', ord_qty, 'Type:', typeof ord_qty);

        const cleanedOrder = Object.assign({}, orderToMove, {
          partNumber: orderToMove.partNumber || movedOrder.partNumber,
          ord_qty: ord_qty,
          date: orderToMove.date || 'N/A',
          D1: !isNaN(orderToMove.D1) ? Number(orderToMove.D1) : 0,
          D2: !isNaN(orderToMove.D2) ? Number(orderToMove.D2) : 0,
          D3: !isNaN(orderToMove.D3) ? Number(orderToMove.D3) : 0,
          D4: !isNaN(orderToMove.D4) ? Number(orderToMove.D4) : 0,
          comment: orderToMove.comment || 'No comments'
        });

        console.log('Cleaned Order before adding to machine:', JSON.stringify(cleanedOrder));

        if (!cleanedOrder.partNumber || isNaN(cleanedOrder.ord_qty)) {
          console.error('Invalid data detected:', cleanedOrder);
        } else {
          this.machines[machineIndex].orders = [...this.machines[machineIndex].orders, cleanedOrder];
          this.unscheduledOrders = this.unscheduledOrders.filter(order => order.partNumber !== movedOrder.partNumber);
          console.log('Updated unscheduled orders:', this.unscheduledOrders);
          this.updateUnscheduled([...this.unscheduledOrders]);
        }
      } else {
        console.error('Machine not found:', movedOrder.toMachine);
      }
    },

        // Method to mark an employee as dropped/assigned
        markResourceDropped(employeeId) {
    console.log(`Employee ${employeeId} was dropped`);  // <-- Add this to confirm event reception
    this.$refs.resourcesView.markAsAssigned(employeeId); // Trigger the markAsAssigned method in ResourcesView
  },

    updateSchedule(event) {
      const { machine, partNumber, ...cleanedOrder } = event;
      const machineIndex = this.machines.findIndex(m => m.name === machine);
      const orderIndex = this.machines[machineIndex].orders.findIndex(order => order.partNumber === partNumber);

      if (machineIndex !== -1) {
        if (orderIndex !== -1) {
          this.machines[machineIndex].orders[orderIndex] = cleanedOrder;
        } else {
          this.machines[machineIndex].orders.push(cleanedOrder);
        }
        this.machines = [...this.machines];
      }
    },

    updateUnscheduled(orders) {
      console.log('PARENT BEFORE SPLIT:', {
        incomingTotal: orders.length,
        incomingSales: orders.filter(o => String(o.unscheduled_bucket || '').toUpperCase() === 'SALES').length,
        incomingSalesPlus: orders.filter(o => String(o.unscheduled_bucket || '').toUpperCase() === 'SALES_PLUS').length,
        incomingForecast: orders.filter(o => String(o.unscheduled_bucket || '').toUpperCase() === 'FORECAST').length,
        currentUnscheduledOrders: this.unscheduledOrders.length,
        currentOutsideWindowOrders: this.outsideWindowOrders.length,
      });

      this.unscheduledOrders = orders.filter(order =>
        String(order.unscheduled_bucket || '').toUpperCase() !== 'SALES_PLUS'
      );

      this.outsideWindowOrders = orders.filter(order =>
        String(order.unscheduled_bucket || '').toUpperCase() === 'SALES_PLUS'
      );

      console.log('PARENT AFTER SPLIT:', {
        unscheduledOrders: this.unscheduledOrders.length,
        outsideWindowOrders: this.outsideWindowOrders.length,
        combinedTotal: this.combinedUnscheduledOrders.length,
        salesPlusRowsForDraggedItem: this.outsideWindowOrders
          .filter(o => String(o.item_no || o.partNumber || '').trim() === 'MHP25R6B-05')
          .map(o => ({
            item_no: o.item_no,
            partNumber: o.partNumber,
            ord_qty: o.ord_qty,
            bucket: o.unscheduled_bucket,
            req_ship_dt: o.req_ship_dt,
            demand_bucket: o.demand_bucket
          }))
      });
    },

    closeForecastPopup() {
    this.showForecastPopup = false;
    },

    moveToTrash(partNumber) {
      const order = this.unscheduledOrders.find(order => order.partNumber === partNumber);
      if (order) {
        this.trashOrders.push(order);
        this.unscheduledOrders = this.unscheduledOrders.filter(order => order.partNumber !== partNumber);
        this.updateUnscheduled(this.unscheduledOrders);
        console.log('Updated unscheduled orders after moving to trash:', this.unscheduledOrders);
      }
    },

    restoreOrder(partNumber) {
      const order = this.trashOrders.find(order => order.partNumber === partNumber);
      if (order) {
        this.unscheduledOrders.push(order);
        this.trashOrders = this.trashOrders.filter(order => order.partNumber !== partNumber);
        this.updateUnscheduled(this.unscheduledOrders);
        console.log('Updated unscheduled orders after restoring from trash:', this.unscheduledOrders);
      }
    },

    lockMachine(machineId) {
      const loc = (this.selectedLocation || "D").toUpperCase().slice(0, 1);

      const machine = this.machines.find(m => m.id === machineId);
      if (!machine) return;

      const machinesPayload = {
        [machineId]: (machine.orders || [])
          .map(o => o.orderId ?? o.ord_no ?? o.ordNo)   // support both naming styles
          .filter(v => v != null && String(v).trim() !== "" && String(v) !== "undefined")
          .map(v => String(v))
      };

      axios.post('/saveScheduleLocks', {
        loc,
        machines: machinesPayload,
        mode: "merge"   // 👈 IMPORTANT (see below)
      })
      .then(res => {
        console.log("✅ Machine locked:", res.data);
        alert(`✅ Locked ${machineId}`);
        this.fetchCurrentSchedule(); // refresh UI from DB
      })
      .catch(err => {
        console.error("❌ lockMachine error:", err);
        alert("❌ Could not lock machine");
      });
    },

  unlockMachine(machineId) {
    const loc = (this.selectedLocation || "D").toUpperCase().slice(0, 1);

    axios.post('/unlockScheduleLocksMachine', {
      loc,
      machine: machineId
    })
    .then(res => {
      console.log("🔓 Machine unlocked:", res.data);
      alert(`🔓 Unlocked ${machineId}`);
      this.fetchCurrentSchedule();
    })
    .catch(err => {
      console.error("❌ unlockMachine error:", err);
      alert("❌ Could not unlock machine");
    });
  },

  toggleMachineLock(machineId) {
    const machine = this.machines.find(m => m.id === machineId);
    if (!machine) return;

    if (machine.locked) {
      // 🔓 UNLOCK
      axios.post('/unlockScheduleLocksMachine', {
        loc: (this.selectedLocation || "D").toUpperCase().slice(0, 1),
        machine: machineId
      })
      .then(() => {
        console.log(`🔓 Unlocked ${machineId}`);
        this.fetchCurrentSchedule();
      })
      .catch(err => {
        console.error("❌ unlockMachine error:", err);
        alert("❌ Could not unlock machine");
      });

    } else {
      // 🔒 LOCK
      const machinesPayload = {
        [machineId]: (machine.orders || [])
          .map((o, index) => {
            const ordNo = o.orderId ?? o.ord_no ?? o.ordNo;
            const itemNo = o.partNumber ?? o.item_no ?? o.itemNo;
            const ordQtyRemaining = o.ord_qty ?? o.ordQty ?? o.qty_remaining ?? 0;

            return {
              ord_no: ordNo,
              item_no: itemNo,
              ord_qty_remaining: Number(ordQtyRemaining) || 0,
              run_sequence: index + 1
            };
          })
          .filter(row =>
            row.ord_no != null &&
            String(row.ord_no).trim() !== "" &&
            String(row.ord_no).trim() !== "undefined"
          )
      };

      axios.post('/saveScheduleLocks', {
        loc: (this.selectedLocation || "D").toUpperCase().slice(0, 1),
        machines: machinesPayload,
        mode: "replace" // ✅ IMPORTANT: use replace, not merge
      })
      .then(() => {
        console.log(`🔒 Locked ${machineId}`);
        this.fetchCurrentSchedule();
      })
      .catch(err => {
        console.error("❌ lockMachine error:", err);
        alert("❌ Could not lock machine");
      });
    }
  },

  async setKeepManualSequence(payload) {
    const loc = String(this.selectedLocation || 'D')
      .trim()
      .toUpperCase()
      .slice(0, 1);

    const ordNo = Number(payload?.ord_no);

    const keepManualSequence =
      payload?.keep_manual_sequence === true;

    if (!Number.isInteger(ordNo) || ordNo <= 0) {
      console.error(
        'Invalid Keep Position payload:',
        payload
      );
      return;
    }

    try {
      const res = await axios.post(
        '/setKeepManualSequence',
        {
          loc,
          ord_no: ordNo,
          keep_manual_sequence: keepManualSequence
        }
      );

      console.log(
        '✅ Keep Position saved:',
        res.data
      );

    } catch (err) {
      console.error(
        '❌ Keep Position save failed:',
        err.response?.data || err
      );

      alert(
        err.response?.data?.error ||
        'Could not save Keep Position.'
      );

      // Checkbox was changed locally.
      // If the save failed, restore the DB value.
      await this.fetchCurrentSchedule();
    }
  },

  async setWorkOrderExecutionFlags(payload) {
    const loc = String(this.selectedLocation || 'D')
      .trim()
      .toUpperCase()
      .slice(0, 1);

    const ordNo = Number(payload?.ord_no);

    if (!Number.isInteger(ordNo) || ordNo <= 0) {
      console.error(
        'Invalid WO execution flag payload:',
        payload
      );
      return;
    }

    try {
      const res = await axios.post(
        '/setWorkOrderExecutionFlags',
        {
          loc,
          ord_no: ordNo,

          shift_changeover_1st:
            payload?.shift_changeover_1st === true,

          shift_changeover_2nd:
            payload?.shift_changeover_2nd === true,

          exact_quantity:
            payload?.exact_quantity === true
        }
      );

      console.log(
        '✅ WO execution flags saved:',
        res.data
      );

    } catch (err) {
      console.error(
        '❌ WO execution flags save failed:',
        err.response?.data || err
      );

      alert(
        err.response?.data?.error ||
        'Could not save work order instructions.'
      );

      // Restore database truth
      await this.fetchCurrentSchedule();
    }
  },


    // drag and drop for D day scheduling:

    async handleRunPlanMove(payload) {
      try {
        // optimistic UI update (optional but recommended)
        const { ord_no, from_day, to_day } = payload;

        // Find the order in current machines state and update immediately
        for (const m of this.machines) {
          const wo = (m.orders || []).find(o => o.orderId === ord_no);
          if (!wo) continue;

          const fromKey = `RUN ${from_day}`;
          const toKey = `RUN ${to_day}`;

          const moved = Number(wo[fromKey] || 0);
          if (!moved || moved <= 0) return;

          wo[fromKey] = 0;
          wo[toKey] = Number(wo[toKey] || 0) + moved;

          // force Vue update
          this.machines = [...this.machines];
          break;
        }

        // persist to backend
        await axios.post('/runPlan/move', payload);

        // optional: re-fetch schedule to ensure server truth
        // await this.fetchCurrentSchedule();

      } catch (err) {
        console.error('handleRunPlanMove failed:', err);
        alert('Run move failed. Refreshing schedule…');

        // rollback by reloading from server
        await this.fetchCurrentSchedule();
      }
    },


    async handleRunPlanSet(payload) {
      try {
        const { ord_no, day_num, run_qty_override } = payload;

        // optimistic update
        for (const m of this.machines) {
          const wo = m.orders?.find(o => o.orderId === ord_no);
          if (!wo) continue;

          wo[`RUN ${day_num}`] = run_qty_override;
          this.machines = [...this.machines];
          break;
        }

        await axios.post('/runPlan/set', payload);

      } catch (err) {
        console.error('run-plan-set failed:', err);
        alert('Failed to update run quantity. Refreshing…');
        await this.fetchCurrentSchedule();
      }
    },

    onDragStart(resource) {
      this.draggedResource = resource; // Store the dragged resource
    },
    onDrop(machine) {
      console.log(`Dropped resource ${this.draggedResource.employee_name} onto ${machine.name}`);
      // Handle resource assignment to the machine

    },


fetchWorkOrderStatuses() {
  axios.get('/workOrderStatuses')
    .then(res => {
      this.workOrderStatuses = res.data || [];
      console.log('WO statuses loaded:', this.workOrderStatuses);
    })
    .catch(err => {
      console.error('Error fetching WO statuses:', err);
    });
},

async checkConnectionHealth() {
  try {
    const res = await axios.get('/health/connections', {
      params: { location: this.selectedLocation || 'D' }
    });

    this.connectionHealth = {
      overallStatus: res.data.overallStatus || 'healthy',
      userMessage: res.data.userMessage || 'Pablo is connected.',
      macola: res.data.macola || {
        connected: true,
        message: 'Connected to Macola'
      },
      magic: res.data.magic || {
        connected: true,
        message: 'Connected to Magic'
      }
    };

    console.log('✅ Connection health:', this.connectionHealth);
  } catch (err) {
    const data = err.response?.data || {};

    this.connectionHealth = {
      overallStatus: data.overallStatus || 'degraded',
      userMessage:
        data.userMessage ||
        "Contact Mr. Kaczmarek to restart me, cuz I ain't able to restart mice elf from here.",
      macola: data.macola || {
        connected: false,
        message: 'Macola connection unavailable'
      },
      magic: data.magic || {
        connected: false,
        message: 'Magic connection unavailable'
      }
    };

    console.error('❌ Connection health failed:', this.connectionHealth);
  }
},

async openMachineHoursMaintenance({ machineName }) {
    this.machineHoursError = "";
    this.machineHoursSuccess = "";
    this.machineHoursLoading = true;

    const loc = String(this.selectedLocation || "")
      .trim()
      .toUpperCase()
      .slice(0, 1);

    this.selectedMachineHours = {
      machine: machineName,
      loc,
      allowed_hours: 18
    };

    this.showMachineHoursModal = true;

    try {
      const response = await axios.get("/machine-hours", {
        params: {
          machine: machineName,
          loc
        }
      });

      this.selectedMachineHours = {
        machine: response.data.machine,
        loc: response.data.loc,
        allowed_hours: Number(response.data.allowed_hours ?? 18)
      };
    } catch (err) {
      console.error("openMachineHoursMaintenance error:", err);

      this.machineHoursError =
        err?.response?.data?.error || "Failed to load machine hours.";
    } finally {
      this.machineHoursLoading = false;
    }
  },

  closeMachineHoursMaintenance() {
    this.showMachineHoursModal = false;
    this.selectedMachineHours = null;
    this.machineHoursError = "";
    this.machineHoursSuccess = "";
  },

  async saveMachineHours() {
    this.machineHoursError = "";
    this.machineHoursSuccess = "";

    if (!this.selectedMachineHours) return;

    const allowedHours = Number(this.selectedMachineHours.allowed_hours);

    if (!Number.isFinite(allowedHours) || allowedHours < 0) {
      this.machineHoursError = "Please enter a valid non-negative number.";
      return;
    }

    try {
      this.machineHoursSaving = true;

      await axios.put("/machine-hours", {
        machine: this.selectedMachineHours.machine,
        loc: this.selectedMachineHours.loc,
        allowed_hours: allowedHours
      });

      this.machineHoursSuccess = "✅ Machine hours saved.";

      // Important: refresh schedule/load after capacity changes
      await this.fetchCurrentSchedule();

    } catch (err) {
      console.error("saveMachineHours error:", err);

      this.machineHoursError =
        err?.response?.data?.error || "Failed to save machine hours.";
    } finally {
      this.machineHoursSaving = false;
    }
  },

normalizeMachineName(v) {
  return String(v || '')
    .toUpperCase()
    .replace(/\s+/g, ' ')
    .trim();
},


onUpdateMachineItemLimit({ machineName, value }) {
  if (!machineName) return;

  if (value === null || value === undefined) {
    delete this.machineItemLimits[machineName];
  } else {
    const n = Number(value);
    if (!Number.isFinite(n)) return;
    this.machineItemLimits[machineName] = n;
  }

  this.refreshEngineAndReload('machine-limit-change');
},

fetchResources(location) {
  axios.get('/getResources', { params: { location } })
    .then(res => {
      console.log('/getResources raw response:', {
        status: res.status,
        data: res.data
      });

      this.resourcesList = Array.isArray(res.data) ? res.data : [];
      console.log('resourcesList assigned:', this.resourcesList);
    })
    .catch(err => {
      console.error('❌ Error fetching resources:', {
        message: err.message,
        responseStatus: err.response?.status,
        responseData: err.response?.data
      });
      this.resourcesList = [];
    });
},


fetchMachineNotes() {
  const location = this.selectedLocation || 'D';

  this.machineNotes = [];

  //console.log('📤 fetchMachineNotes() sending:', { location });

  axios.get('/getMachineNotes', { params: { location } })
    .then(res => {
      console.log('/getMachineNotes raw response:', {
        status: res.status,
        data: res.data
      });
      this.machineNotes = Array.isArray(res.data) ? res.data : [];
      console.log('machineNotes assigned:', this.machineNotes);
    })
    .catch(err => {
      console.error('❌ Error fetching machine notes:', {
        message: err.message,
        responseStatus: err.response?.status,
        responseData: err.response?.data
      });
    })
    .finally(() => {
      console.log('fetchMachineNotes finished');
    });
},


autoSaveMachineNote(noteText) {
    const loc = (this.selectedLocation || "D").toUpperCase();
    const machine = (this.selectedNotesMachine?.name || "").trim();

    if (!loc || !machine) return;

    this.machineNoteSaving = true;

    axios.put("/saveMachineNote", {
      loc,
      machine,
      note_text: noteText,
      updated_by: this.$root?.username || null, // optional
      // note_dt: optional if you support it
    })
    .then((res) => {
      // keep local cache in sync so computed reflects latest without refetch
      const saved = res.data;
      const row = this.machineNotes.find(n => (n.machine || "").trim() === machine && (n.loc || "").trim() === loc);
      if (row) row.note_text = saved.note_text;
      else this.machineNotes.push(saved);
    })
    .catch(err => console.error("Autosave machine note failed:", err))
    .finally(() => {
      this.machineNoteSaving = false;
    });
  },

  clearMachineResourcesInUi() {
  this.machines.forEach(m => {
    m.operator = null;
    m.boxer = null;
  });
},


  fetchMachineResources() {
  const location = (this.selectedLocation || 'D').toUpperCase();

  axios.get('/getMachineResources', { params: { location } })
    .then(res => {
      const rows = Array.isArray(res.data) ? res.data : [];

      // Build lookup by machine name
      const map = new Map(rows.map(r => [String(r.machine).trim(), r]));

      // Apply to machines in current state
      this.machines.forEach(m => {
        const key = String(m.name || '').trim();
        const hit = map.get(key);

        m.operator = hit?.operator || null;
        m.boxer = hit?.boxer || null;
      });

      console.log('✅ machine resources applied for loc', location);
    })
    .catch(err => {
      console.error('❌ Error fetching machine resources:', {
        message: err.message,
        responseStatus: err.response?.status,
        responseData: err.response?.data
      });
    });
},



saveMachineNote() {
  const machineName = (this.selectedNotesMachine?.name || "").trim();
  const payload = {
    location: this.selectedLocation || "D",
    machine: machineName,
    note_text: this.machineNoteDraft || ""
  };

  return axios.put("/saveMachineNote", payload)
    .then(() => {
      // update local cache so computed reflects saved value without refetch
      const row = this.machineNotes.find(n => (n.machine || "").trim() === machineName);
      if (row) row.note_text = payload.note_text;
      else this.machineNotes.push(payload);

      // optional: close modal
      // this.closeMachineNotesModal();
    })
    .catch(err => console.error("Error saving machine note:", err));
},

getWoRowKey(wo, idx = 0) {
  const ordNo =
    wo?.orderId ??
    wo?.ord_no ??
    wo?.ordNo;

  if (
    ordNo !== null &&
    ordNo !== undefined &&
    String(ordNo).trim() !== ''
  ) {
    return String(ordNo);
  }

  return `${this.getWoItemNo(wo)}-${idx}`;
},

getWoItemNo(wo) {
  return String(
    wo?.partNumber ??
    wo?.item_no ??
    ''
  ).trim();
},

getWoOrdNo(wo) {
  return String(
    wo?.orderId ??
    wo?.ord_no ??
    ''
  ).trim();
},

getWoShortageIndicators(wo) {
  const raw =
    wo?.shortageIndicators ??
    wo?.shortage_indicators ??
    '';

  let values = [];

  if (Array.isArray(raw)) {
    values = raw;
  } else {
    values = String(raw).split(',');
  }

  return [
    ...new Set(
      values
        .map(value => String(value || '').trim())
        .filter(Boolean)
    )
  ];
},

hasWoShortages(wo) {
  if (this.getWoShortageIndicators(wo).length > 0) {
    return true;
  }

  const legacyValue = String(
    wo?.insufficiency ??
    wo?.Insufficiencies ??
    ''
  )
    .trim()
    .toUpperCase();

  return legacyValue === 'Y' || legacyValue === 'YES';
},



isWoShortageExpanded(wo, idx = 0) {
  const rowKey = this.getWoRowKey(wo, idx);

  return Boolean(
    this.expandedShortageRows[rowKey]
  );
},

getWoShortageDetails(wo) {
  const ordNo = this.getWoOrdNo(wo);

  return this.insufficiencyDetailsByItem[ordNo] || [];
},

async toggleWoShortageRow(wo, idx = 0) {
  if (!this.hasWoShortages(wo)) return;

  const rowKey = this.getWoRowKey(wo, idx);
  const isCurrentlyExpanded = Boolean(
    this.expandedShortageRows[rowKey]
  );

  this.expandedShortageRows = {
    ...this.expandedShortageRows,
    [rowKey]: !isCurrentlyExpanded
  };

  // Only load details when opening the row.
  if (!isCurrentlyExpanded) {
    await this.loadWoShortageDetails(wo);
  }
},

async loadWoShortageDetails(wo) {
  const itemNo = this.getWoItemNo(wo);
  const ordNo = this.getWoOrdNo(wo);

  if (!itemNo || !ordNo) return;

  // All loading, error, and detail caches are keyed by WO number.
  if (
    Object.prototype.hasOwnProperty.call(
      this.insufficiencyDetailsByItem,
      ordNo
    )
  ) {
    return;
  }

  // Prevent duplicate requests from rapid clicking.
  if (this.shortageLoadingByItem[ordNo]) {
    return;
  }

  const loc = String(this.selectedLocation || 'D')
    .trim()
    .toUpperCase()
    .slice(0, 1);

  this.shortageLoadingByItem = {
    ...this.shortageLoadingByItem,
    [ordNo]: true
  };

  this.shortageErrorByItem = {
    ...this.shortageErrorByItem,
    [ordNo]: ''
  };

  try {
    const response = await axios.get(
      '/getInsufficiencyDetails',
      {
        params: {
          location: loc,
          item_no: itemNo,
          ord_no: ordNo
        }
      }
    );

    const rows = Array.isArray(response.data)
      ? response.data
      : [];

    const mappedRows = rows.map(detail => ({
      ord_no: String(
        detail.ord_no || ordNo
      ).trim(),

      item_no: String(
        detail.item_no || itemNo
      ).trim(),

      component_item_no: String(
        detail.component_item_no ??
        detail.item_no_bom ??
        ''
      ).trim(),

      qty_needed:
        detail.qty_needed === null ||
        detail.qty_needed === undefined ||
        detail.qty_needed === ''
          ? null
          : Number(detail.qty_needed),

      qty_on_hand:
        detail.qty_on_hand === null ||
        detail.qty_on_hand === undefined ||
        detail.qty_on_hand === ''
          ? null
          : Number(detail.qty_on_hand),

      qty_available_for_wo:
        detail.qty_available_for_wo === null ||
        detail.qty_available_for_wo === undefined ||
        detail.qty_available_for_wo === ''
          ? null
          : Number(detail.qty_available_for_wo),

      shortage:
        detail.shortage === null ||
        detail.shortage === undefined ||
        detail.shortage === ''
          ? null
          : Number(detail.shortage),

      cumulative_shortage:
        detail.cumulative_shortage === null ||
        detail.cumulative_shortage === undefined ||
        detail.cumulative_shortage === ''
          ? null
          : Number(detail.cumulative_shortage),

      shortage_label: String(
        detail.shortage_label || ''
      ).trim(),

      component_type: String(
        detail.component_type || ''
      ).trim()
    }));

    this.insufficiencyDetailsByItem = {
      ...this.insufficiencyDetailsByItem,
      [ordNo]: mappedRows
    };
  } catch (error) {
    console.error(
      `Error loading shortage details for WO ${ordNo}, item ${itemNo}:`,
      error.response?.data || error
    );

    this.insufficiencyDetailsByItem = {
      ...this.insufficiencyDetailsByItem,
      [ordNo]: []
    };

    this.shortageErrorByItem = {
      ...this.shortageErrorByItem,
      [ordNo]:
        error.response?.data?.error ||
        'Could not load shortage details.'
    };
  } finally {
    this.shortageLoadingByItem = {
      ...this.shortageLoadingByItem,
      [ordNo]: false
    };
  }
},

openMachineNotesModal(machine) {
  this.selectedNotesMachine = machine;

  // Begin every Notes session in a clean collapsed state.
  this.expandedShortageRows = {};
  this.insufficiencyDetailsByItem = {};
  this.shortageLoadingByItem = {};
  this.shortageErrorByItem = {};

  this.showMachineNotesModal = true;

  // Populate the machine-level textarea.
  this.machineNoteDraft = this.currentMachineNote || '';

  console.log('📝 Notes modal opened for machine:', {
    machineName: machine?.name,
    ordersCount: machine?.orders?.length || 0,
    machineNoteDraft: this.machineNoteDraft
  });
},

  closeMachineNotesModal() {
    this.showMachineNotesModal = false;
    this.selectedNotesMachine = null;

    this.expandedShortageRows = {};
    this.insufficiencyDetailsByItem = {};
    this.shortageLoadingByItem = {};
    this.shortageErrorByItem = {};
  },

  queueAutosaveWoNotes(wo) {
    const id = wo.orderId; // stable per WO
    if (!id) return;

    if (this.woSaveTimers[id]) {
      clearTimeout(this.woSaveTimers[id]);
    }

    this.woSaveTimers[id] = setTimeout(() => {
      this.autoSaveWoNotes(wo);
    }, 600);
  },

  autoSaveWoNotes(wo) {
    const loc = (this.selectedLocation || "D").toUpperCase();

    this.woSaving[wo.orderId] = true;

    axios.put("/workOrders/notes", {
      ord_no: wo.orderId,
      ord_type: "P",
      loc,
      note1: wo.wo_status ?? "",   // ✅ goes to user_def_fld_3
      note2: wo.wo_note_1 ?? "",   // ✅ goes to user_def_fld_4
      note3: wo.wo_note_2 ?? ""    // ✅ goes to user_def_fld_5
    })
    .catch(err => console.error("Autosave WO notes failed:", err))
    .finally(() => {
      this.woSaving[wo.orderId] = false;
    });
  },

getMachineNoteForPrint(machineName) {
  const key = this.normalizeMachineName(machineName);
  const locKey = this.normalizeMachineName(this.selectedLocation || 'D'); // uses your normalizer

  const rows = Array.isArray(this.machineNotes) ? this.machineNotes : [];
  const row = rows.find(r => {
    // machine name field (try several likely keys)
    const rName =
      r?.machine ??
      r?.machine_name ??
      r?.name ??
      r?.machineName ??
      r?.machine_nm ??
      '';

    // location field (try several likely keys)
    const rLoc =
      r?.loc ??
      r?.location ??
      r?.plant ??
      r?.site ??
      r?.stk_loc ??
      '';

    const sameMachine = this.normalizeMachineName(rName) === key;

    // If the row has a location value, require it to match.
    // If the row has NO location field at all, allow the machine match to pass.
    const hasLoc = String(rLoc || '').trim().length > 0;
    const sameLoc = !hasLoc || this.normalizeMachineName(rLoc) === locKey;

    return sameMachine && sameLoc;
  });

  if (!row) return '';

  // note field (try several likely keys)
  return String(
    row.note ??
    row.machine_note ??
    row.machine_notes ??
    row.notes ??
    row.comment ??
    row.comments ??
    row.note_text ??
    ''
  );
},

openMachineResourcesModal(machine) {
  console.log('✅ openMachineResourcesModal machine:', machine);

  this.selectedResourcesMachine = machine;
  this.selectedOperatorResourceId = machine.operator?.resource_id ?? null;
  this.selectedBoxerResourceId = machine.boxer?.resource_id ?? null;

  const location = (this.selectedLocation || 'D').toUpperCase();
  this.fetchResources(location);

  this.showMachineResourcesModal = true;
},

  closeMachineResourcesModal() {
    this.showMachineResourcesModal = false;
    this.selectedResourcesMachine = null;
    this.resourcesList = [];
    this.selectedOperatorResourceId = null;
    this.selectedBoxerResourceId = null;
  },

saveMachineResources() {
  if (!this.selectedResourcesMachine) return;

  // block same person in both roles
  if (
    this.selectedOperatorResourceId &&
    this.selectedBoxerResourceId &&
    this.selectedOperatorResourceId === this.selectedBoxerResourceId
  ) {
    alert('Operator and Boxer cannot be the same person.');
    return;
  }

  const operator = this.resourcesList.find(r => r.resource_id === this.selectedOperatorResourceId) || null;
  const boxer = this.resourcesList.find(r => r.resource_id === this.selectedBoxerResourceId) || null;

  // update canonical machine in JIMScheduling
  const target =
    this.machines.find(m => m.id === this.selectedResourcesMachine.id) ||
    this.selectedResourcesMachine;

  target.operator = operator;
  target.boxer = boxer;

  const payload = {
    location: (this.selectedLocation || 'D').toUpperCase(),
    machine: (target.name || '').trim(),
    operator_resource_id: operator?.resource_id ?? null,
    boxer_resource_id: boxer?.resource_id ?? null,
  };

  return axios.put('/setMachineResources', payload)
    .then(res => {
      console.log('✅ /setMachineResources saved:', res.status, res.data);
      this.closeMachineResourcesModal(); // close ONLY on success
    })
    .catch(err => {
      console.error('❌ Error saving machine resources:', {
        message: err.message,
        responseStatus: err.response?.status,
        responseData: err.response?.data
      });
      alert('Saved locally, but failed to persist to DB.');
      // modal stays open so user can retry
    });
},

async fetchPlanNotes() {
  const location = (this.selectedLocation || "D").toUpperCase();

  try {
    const res = await axios.get("/getPlantPlanNotes", {
      params: { location }
    });

    this.planNotes = {
      Day: res.data?.notes?.Day || "",
      Swing: res.data?.notes?.Swing || "",
      Graveyard: res.data?.notes?.Graveyard || ""
    };

    console.log("✅ Plant plan notes loaded:", this.planNotes);
  } catch (err) {
    console.error("❌ Error fetching plant plan notes:", {
      message: err.message,
      responseStatus: err.response?.status,
      responseData: err.response?.data
    });

    this.planNotes = {
      Day: "",
      Swing: "",
      Graveyard: ""
    };
  }
},

async openPlanNotesModal() {
  await this.fetchPlanNotes();
  this.showPlanNotesModal = true;
},

closePlanNotesModal() {
  this.showPlanNotesModal = false;
},

async savePlanNotes() {
  this.planNotesSaving = true;

  try {
    const payload = {
      location: (this.selectedLocation || "D").toUpperCase(),
      notes: {
        Day: this.planNotes.Day || "",
        Swing: this.planNotes.Swing || "",
        Graveyard: this.planNotes.Graveyard || ""
      },
      updated_by: this.$root?.username || null
    };

    const res = await axios.put("/savePlantPlanNotes", payload);

    this.planNotes = {
      Day: res.data?.notes?.Day || "",
      Swing: res.data?.notes?.Swing || "",
      Graveyard: res.data?.notes?.Graveyard || ""
    };

    this.showPlanNotesModal = false;

    console.log("✅ Plant plan notes saved:", this.planNotes);
  } catch (err) {
    console.error("❌ Error saving plant plan notes:", {
      message: err.message,
      responseStatus: err.response?.status,
      responseData: err.response?.data
    });

    alert("Could not save plan notes.");
  } finally {
    this.planNotesSaving = false;
  }
},

async sendMoveOutRequest(r) {
  this.moveOutReqError = "";
  this.moveOutReqSuccess = "";

  try {
    if (!this.selectedDayDemand?.order?.partNumber) {
      this.moveOutReqError = "Missing item number.";
      return;
    }

    const loc = String(this.selectedLocation || "")
      .trim()
      .toUpperCase()
      .slice(0, 1);

    const itemNo = String(this.selectedDayDemand.order.partNumber || "").trim();
    const ordNo = String(r?.ord_no || "").trim();
    const reqShipDt = r?.req_ship_dt || null;


    if (!ordNo) {
      this.moveOutReqError = "Missing sales order number.";
      return;
    }

    this.sendingMoveOutReq = true;

    const payload = {
      loc,
      sender_dept: "Production",
      recipient_dept: "Logistics",
      request_type: "PROD_REQUEST_MOVE_OUT",
      item_no: itemNo,
      payload: {
        item_no: itemNo,
        req_ship_dt: reqShipDt,
        order_nos: [ordNo],
        qty_ordered: Number(r.qty_ordered) || 0,
        reason_code: this.moveOutReasonCode || "CAPACITY"
      },
      requires_replan: false
    };

    await axios.post("/pablotify/request", payload);

    this.moveOutReqSuccess = `✅ Request sent for SO ${ordNo}`;

  } catch (err) {
    console.error("sendMoveOutRequest error:", err);
    this.moveOutReqError = "Failed to send request.";
  } finally {
    this.sendingMoveOutReq = false;
  }
},

//openExcelTab() {
  //const loc = (this.selectedLocation || 'D').toUpperCase();
  //const planningDays = Number(this.planningDays || 1);

  //const payload = {
//    meta: {
  //    location: loc,
    //  planningDays,
      //generatedAt: new Date().toISOString(),
//    },
  //  machines: (this.filteredMachines || []).map(m => ({
    //  name: m.name,
      //machineNote: this.getMachineNoteForPrint(m.name),
//      operatorName: m.operator?.employee_name || '',
  //    boxerName: m.boxer?.employee_name || '',
    //  orders: (m.orders || []).map(o => {
      //  const order = {
        //  orderId: o.orderId ?? o.ord_no ?? '',
          //partNumber: o.partNumber ?? o.item_no ?? '',
 //         ord_qty: o.ord_qty ?? 0,
   //       insufficiency: o.insufficiency ?? '',
     //     wo_note_1: o.wo_note_1 ?? '',
       //   wo_note_2: o.wo_note_2 ?? '',
 //       };

   //     for (let d = 1; d <= planningDays; d++) {
     //     order[`RUN ${d}`] = o[`RUN ${d}`] ?? 0;
       // }

 //       return order;
   //   }),
 //   })),
 // };

 // sessionStorage.setItem('pablo_print_payload', JSON.stringify(payload));

  // Open print view in "export to excel" mode
  //window.open('/print-schedule?export=excel', '_blank');
//},



//openPrintTab() {
  //const loc = (this.selectedLocation || 'D').toUpperCase();
//  const planningDays = Number(this.planningDays || 1);

//  console.log('machineNotes type:', Array.isArray(this.machineNotes) ? 'array' : typeof this.machineNotes, this.machineNotes);
//  console.log('first machine name:', this.filteredMachines?.[0]?.name);
//  console.log('machineNotes[0] keys:', this.machineNotes?.[0] ? Object.keys(this.machineNotes[0]) : null, this.machineNotes?.[0]);



//  const payload = {
  //  meta: {
    //  location: loc,
      //planningDays,
 //     generatedAt: new Date().toISOString(),
   // },
    //machines: (this.filteredMachines || []).map(m => ({
//      name: m.name,
  //    machineNote: this.getMachineNoteForPrint(m.name),
    //  operatorName: m.operator?.employee_name || '',
      //boxerName: m.boxer?.employee_name || '',
//      orders: (m.orders || []).map(o => {
  //      const order = {
    //      orderId: o.orderId ?? o.ord_no ?? '',
      //    partNumber: o.partNumber ?? o.item_no ?? '',
        //  ord_qty: o.ord_qty ?? 0,
          //insufficiency: o.insufficiency ?? '',
 //         wo_note_1: o.wo_note_1 ?? '',
   //       wo_note_2: o.wo_note_2 ?? '',
     //   };

 //       for (let d = 1; d <= planningDays; d++) {
   //       order[`RUN ${d}`] = o[`RUN ${d}`] ?? 0;
     //   }

 //       return order;
   //   }),
//    })),
  //};

//  sessionStorage.setItem('pablo_print_payload', JSON.stringify(payload));

  // History mode route
  //window.open('/print-schedule', '_blank');
//},

buildPabloPrintPayload() {
  const loc = (this.selectedLocation || 'D').toUpperCase();
  const planningDays = Number(this.planningDays || 1);

  return {
    meta: {
      location: loc,
      planningDays,
      generatedAt: new Date().toISOString(),
      planNotes: {
        Day: this.planNotes.Day || "",
        Swing: this.planNotes.Swing || "",
        Graveyard: this.planNotes.Graveyard || ""
      }    
    },
    machines: (this.filteredMachines || []).map(m => ({
      name: m.name,
      machineNote: this.getMachineNoteForPrint(m.name),
      operatorName: m.operator?.employee_name || '',
      boxerName: m.boxer?.employee_name || '',
      orders: (m.orders || []).map(o => {

      if ((o.item_no || o.partNumber) === 'MHP25R6B-06') {
        console.log('PRINT PAYLOAD SOURCE ORDER KEYS:', Object.keys(o));
        console.log('PRINT PAYLOAD SOURCE ORDER SHORT FIELDS:', {
          partNumber: o.partNumber,
          item_no: o.item_no,
          fg_sales_short_qty: o.fg_sales_short_qty,
          fg_shortage_start_day: o.fg_shortage_start_day,
          fg_shortage_start_date: o.fg_shortage_start_date,
          fg_shortage_days: o.fg_shortage_days,
          fg_shortage_dates: o.fg_shortage_dates,
          fg_short_1: o.fg_short_1,
          fg_short_2: o.fg_short_2,
          fg_short_3: o.fg_short_3,
          fg_short_4: o.fg_short_4,
          fg_short_5: o.fg_short_5,
          fg_short_6: o.fg_short_6,
          fg_short_7: o.fg_short_7,
        });
      }
        const order = {
          orderId: o.orderId ?? o.ord_no ?? '',
          partNumber: o.partNumber ?? o.item_no ?? '',
          ord_qty: o.ord_qty ?? 0,

          // Item attributes for Operator Snapshot formatting
          r_value: o.r_value ?? '',
          product_type: o.product_type ?? '',
          item_desc_1: o.item_desc_1 ?? '',
          item_desc_2: o.item_desc_2 ?? '',
          jacket_type: o.jacket_type ?? '',
          macola_family: o.macola_family ?? '',

          insufficiency: o.insufficiency ?? '',

          // Basic FG shortage quantity: sales demand - inventory
          fg_sales_short_qty: Number(o.fg_sales_short_qty ?? 0) || 0,

          // Basic FG shortage timing: sales demand vs inventory only
          fg_shortage_start_day: o.fg_shortage_start_day ?? '',
          fg_shortage_start_date: o.fg_shortage_start_date ?? '',
          fg_shortage_days: o.fg_shortage_days ?? '',
          fg_shortage_dates: o.fg_shortage_dates ?? '',

          standing_note: o.standing_note ?? '',
          wo_note_1: o.wo_note_1 ?? '',
          wo_note_2: o.wo_note_2 ?? '',

          shift_changeover_1st:
            Boolean(o.shift_changeover_1st),

          shift_changeover_2nd:
            Boolean(o.shift_changeover_2nd),

          exact_quantity:
            Boolean(o.exact_quantity),
        };

        for (let d = 1; d <= planningDays; d++) {
          order[`RUN ${d}`] = o[`RUN ${d}`] ?? 0;
          order[`FG SHORT ${d}`] = o[`fg_short_${d}`] ?? o[`FG SHORT ${d}`] ?? 0;
        }

        return order;
      }),
    })),
  };
},

openPrintTab() {
  const payload = this.buildPabloPrintPayload();
  sessionStorage.setItem('pablo_print_payload', JSON.stringify(payload));
  window.open('/print-schedule', '_blank');
},

openExcelTab() {
  const payload = this.buildPabloPrintPayload();
  sessionStorage.setItem('pablo_print_payload', JSON.stringify(payload));
  window.open('/print-schedule?export=excel', '_blank');
},

openOperatorSnapshotPrint() {
  const payload = this.buildPabloPrintPayload();
  sessionStorage.setItem('pablo_print_payload', JSON.stringify(payload));
  window.open('/operator-snapshot?print=1', '_blank');
},

openOperatorSnapshotExcel() {
  const payload = this.buildPabloPrintPayload();
  sessionStorage.setItem('pablo_print_payload', JSON.stringify(payload));
  window.open('/operator-snapshot?export=excel', '_blank');
},


  async openCreateWoModal() {
  this.showCreateWoModal = true;

  // reset
  this.createWoUi.error = '';
  this.createWoUi.loading = false;
  this.createWoForm.machine = '';
  this.createWoForm.partNumber = '';
  this.createWoForm.ord_qty = null;
  this.createWoForm.ord_status = 'P';

  this.createWoOptions.items = [];

  // load machines for selected location
  await this.fetchCreateWoMachines();
},

closeCreateWoModal() {
  this.showCreateWoModal = false;
},

async fetchCreateWoMachines() {
  const location = this.selectedLocation; // from your computed
  this.createWoOptions.loadingMachines = true;

  try {
    // NOTE: using "location" here; backend accepts loc too
    const resp = await axios.get('/machine-list', { params: { location } });
    this.createWoOptions.machines = Array.isArray(resp.data) ? resp.data : [];
  } catch (err) {
    console.error('❌ fetchCreateWoMachines failed:', err);
    this.createWoUi.error =
      err?.response?.data?.message || 'Failed to load machines.';
  } finally {
    this.createWoOptions.loadingMachines = false;
  }
},

async fetchCreateWoItemsForMachine() {
  const location = this.selectedLocation;
  const machine = (this.createWoForm.machine || '').trim();

  this.createWoForm.partNumber = '';
  this.createWoOptions.items = [];

  if (!machine) return;

  this.createWoOptions.loadingItems = true;

  try {
    const resp = await axios.get('/items-for-machine', { params: { location, machine } });
    this.createWoOptions.items = Array.isArray(resp.data) ? resp.data : [];
  } catch (err) {
    console.error('❌ fetchCreateWoItemsForMachine failed:', err);
    this.createWoUi.error =
      err?.response?.data?.message || 'Failed to load items for machine.';
  } finally {
    this.createWoOptions.loadingItems = false;
  }
},

async submitCreateWorkOrder() {
  this.createWoUi.error = '';
  this.createWoUi.loading = true;

  const payload = {
    machine: this.createWoForm.machine,             // REQUIRED by UX
    partNumber: (this.createWoForm.partNumber || '').trim(),
    ord_qty: Number(this.createWoForm.ord_qty),
    loc: (this.selectedLocation || 'D').toUpperCase(),
    ord_status: (this.createWoForm.ord_status || 'P').trim()
  };

  if (!payload.machine) {
    this.createWoUi.loading = false;
    this.createWoUi.error = 'Machine is required.';
    return;
  }
  if (!payload.partNumber || !payload.ord_qty || !payload.loc) {
    this.createWoUi.loading = false;
    this.createWoUi.error = 'partNumber, ord_qty, and loc are required.';
    return;
  }

  try {
    const resp = await axios.post('/create-work-order', payload);
    console.log('✅ Work order created:', resp.data);

    // close + refresh (same pattern you use)
    this.showCreateWoModal = false;

    this.fetchCurrentSchedule();
    this.fetchProductionSchedule();
    this.fetchUnscheduledForecasts();
    this.fetchMaterialAlerts();
  } catch (err) {
    console.error('❌ Create Work Order failed:', err);
    this.createWoUi.error =
      err?.response?.data?.message ||
      err?.message ||
      'Error creating work order.';
  } finally {
    this.createWoUi.loading = false;
  }
},

async handlePendingOrdersCommitted(payload) {
  console.log('✅ Pending orders committed:', payload);

  // Reload the production cards so source/sync_status are read again.
  await this.fetchCurrentSchedule();

  // Reload unscheduled recommendations because pending coverage changed.
  await this.fetchProductionSchedule();
  await this.fetchOutsideWindowDemand();
  await this.fetchUnscheduledForecasts();
},



async openDayDemandModal(payload) {
    const { order, dayIndex } = payload;

    this.selectedDayDemand = {
      order,
      dayIndex,
      rows: [],
      total_qty: 0,
      line_count: 0,
      loading: true,
      error: null,
    };
    this.showDayDemandModal = true;

    try {
      const res = await axios.get('/getSalesDemandDetail', {
        params: {
          location: this.selectedLocation,
          item_no: order.partNumber,
          production_day: dayIndex,
        },
      });

      const data = res.data || {};
      this.selectedDayDemand.rows = data.rows || [];
      this.selectedDayDemand.total_qty = data.total_qty || 0;
      this.selectedDayDemand.line_count = data.line_count || 0;
      this.selectedDayDemand.loading = false;
    } catch (err) {
      console.error('[openDayDemandModal] error:', err);
      this.selectedDayDemand.loading = false;
      this.selectedDayDemand.error = 'Failed to load sales demand';
    }
  },

  closeDayDemandModal() {
    this.showDayDemandModal = false;
    this.selectedDayDemand = null;
    this.moveOutReqError = "";
    this.moveOutReqSuccess = "";
  },

  async openMachineLoadModal(payload) {
  const { machineName } = payload;

  this.selectedMachineLoad = {
    machine: machineName,
    loc: this.selectedLocation,
    allowed_hours: 0,
    rows: [],
    loading: true,
    error: null,
  };
  this.showMachineLoadModal = true;

  try {
    const res = await axios.get('/getMachineDayLoad', {
      params: { location: this.selectedLocation },
    });

    const allRows = res.data || [];
    const rows = allRows.filter(r => r.machine === machineName);

    this.selectedMachineLoad.rows = rows;
    this.selectedMachineLoad.allowed_hours = rows.length ? rows[0].allowed_hours : 0;
    this.selectedMachineLoad.loc = rows.length ? rows[0].loc : this.selectedLocation;
    this.selectedMachineLoad.loading = false;
  } catch (err) {
    console.error('[openMachineLoadModal] error:', err);
    this.selectedMachineLoad.loading = false;
    this.selectedMachineLoad.error = 'Failed to load machine load';
  }
},

closeMachineLoadModal() {
  this.showMachineLoadModal = false;
  this.selectedMachineLoad = null;
},


formatDate(d) {
  if (!d) return '';

  const s = String(d).trim();

  // YYYY-MM-DD → treat as local date (NO timezone shift)
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) {
    return `${m[2]}/${m[3]}/${m[1]}`;
  }

  // fallback for true timestamps / Date objects
  const dt = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) return s;
  return dt.toLocaleDateString();
},


fetchThroughputData() {
  const loc = (this.selectedLocation || 'D').toUpperCase();

  axios.get('/getThroughputData', {
    params: { loc }
  })
  .then(response => {
    this.throughput = response.data;
    console.log(`Throughput data fetched for loc=${loc}:`, this.throughput);
  })
  .catch(error => {
    console.error('Error fetching throughput data:', error);
  });
},

fetchMachines() {
  const loc = this.selectedLocation || 'D';
  console.log("📤 fetchMachines() sending loc:", loc);

  axios.get('/getJimSchedulingMachines', { params: { loc } })
    .then(response => {
      console.log("📥 fetchMachines() response:", response.data);

      this.machines = response.data.map(machineId => ({
        id: machineId,
        name: machineId,
        orders: []
      }));

      this.fetchCurrentSchedule();
    })
    .catch(error => {
      console.error('❌ Error fetching machines:', error);
    });
},
    
//updated for JPL and New Pablo - 05-08-2025
fetchCurrentSchedule() {
  return axios.get('/getCurrentSchedule', {
    params: { location: this.selectedLocation || 'D' }
  })
  .then(response => {
    const orders = response.data || [];

    console.log("[fetchCurrentSchedule] r_value sample:", orders.slice(0, 25).map(o => ({
      item_no: o.item_no,
      r_value: o.r_value,
      product_type: o.product_type,
      item_desc_2: o.item_desc_2,
      jacket_type: o.jacket_type,
      macola_family: o.macola_family
    })));

    // ✅ Build machine lock map from returned rows
    // If ANY order in a machine has locked_machine / locked_sequence → machine is locked
    const lockedMachines = new Set(
      orders
        .filter(o => o.locked_machine)          // depends on your SELECT alias
        .map(o => String(o.locked_machine))
    );

    this.machines.forEach(machine => {
      const machineOrders = orders
        .filter(order => order.machine === machine.id)
        .map(order => {
          const mappedOrder = {
            partNumber: order.item_no,
            qoh: Number(order.qoh) || 0,
            ord_qty: Number(order.ord_qty) || 0,
            date: order.start_dt,
            orderId: order.ord_no,

            source: order.source || '',
            sync_status: order.sync_status || '',
         
            r_value: order.r_value,
            product_type: order.product_type,
            item_desc_1: order.item_desc_1,
            item_desc_2: order.item_desc_2,
            jacket_type: order.jacket_type,
            macola_family: order.macola_family,

            // Keep the legacy Y/N field temporarily.
            insufficiency: order.Insufficiencies,

            // Comma-separated material shortage badges, such as:
            // I,C,J
            // B,Bx
            shortageIndicators: String(
              order.shortage_indicators ??
              order.shortageIndicators ??
              ''
            ).trim(),

            fg_sales_short_qty: Number(order.fg_sales_short_qty) || 0,

            // Basic FG shortage timing: sales demand vs inventory only
            fg_shortage_start_day: order.fg_shortage_start_day ?? '',
            fg_shortage_start_date: order.fg_shortage_start_date ?? '',
            fg_shortage_days: order.fg_shortage_days ?? '',
            fg_shortage_dates: order.fg_shortage_dates ?? '',

            // Daily cumulative FG shortage quantities from backend aliases
            fg_short_1: Number(order.fg_short_1) || 0,
            fg_short_2: Number(order.fg_short_2) || 0,
            fg_short_3: Number(order.fg_short_3) || 0,
            fg_short_4: Number(order.fg_short_4) || 0,
            fg_short_5: Number(order.fg_short_5) || 0,
            fg_short_6: Number(order.fg_short_6) || 0,
            fg_short_7: Number(order.fg_short_7) || 0,

            wo_status: order.wo_status,
            wo_note_1: order.wo_note_1,
            wo_note_2: order.wo_note_2,

            standing_note: order.standing_note ?? '',

            // Operational sequence fields
            sequence_machine: order.sequence_machine || null,

            run_sequence:
              order.run_sequence === null ||
              order.run_sequence === undefined
                ? null
                : Number(order.run_sequence),

            is_unreviewed: Boolean(order.is_unreviewed),
            sequence_source: order.sequence_source || null,

            // Partial / already-started WO
            has_reported_prod:
              Number(order.has_reported_prod || 0) === 1,

            // If true, Pablo will respect the scheduler's sequence
            // instead of automatically promoting this partial WO.
            keep_manual_sequence:
              Boolean(order.keep_manual_sequence),
            
            shift_changeover_1st:
              Boolean(order.shift_changeover_1st),

            shift_changeover_2nd:
              Boolean(order.shift_changeover_2nd),

            exact_quantity:
              Boolean(order.exact_quantity),

            // Machine lock fields
            locked_machine: order.locked_machine || null,

            locked_sequence:
              order.locked_sequence === null ||
              order.locked_sequence === undefined
                ? null
                : Number(order.locked_sequence),

            is_locked: Boolean(order.is_locked),
            locked: Boolean(order.is_locked)
          };

          // D columns
          for (let i = 1; i <= this.planningDays; i++) {
            mappedOrder[`D ${i}`] = Number(order[`D ${i}`]) || 0;
          }

          // RUN + MUST
          for (let i = 1; i <= this.planningDays; i++) {
            mappedOrder[`RUN ${i}`] = Number(order[`RUN ${i}`]) || 0;
            mappedOrder[`MUST ${i}`] = Number(order[`MUST ${i}`]) || 0;
          }

          mappedOrder.MUST_ANY = Number(order.MUST_ANY) || 0;

          return mappedOrder;
        });

      // machine_run_sequence is the authoritative display order.
      machineOrders.sort((a, b) => {
        const aSequence = Number.isInteger(a.run_sequence)
          ? a.run_sequence
          : Number.MAX_SAFE_INTEGER;

        const bSequence = Number.isInteger(b.run_sequence)
          ? b.run_sequence
          : Number.MAX_SAFE_INTEGER;

        if (aSequence !== bSequence) {
          return aSequence - bSequence;
        }

        // Stable fallback for a row that has not been reconciled yet.
        return Number(a.orderId || 0) - Number(b.orderId || 0);
      });

      machine.orders = machineOrders;

      // ✅ SET machine.locked so button turns red
      machine.locked = lockedMachines.has(machine.id);
    });

    this.machines = [...this.machines];
    console.log("✅ Machines updated with locks:", this.machines);
  })
  .catch(error => {
    console.error("❌ Error fetching current schedule:", error);
  });
},

//Udpated for JPL 02-21-2025
// Updated for JPL 02-21-2025
fetchProductionSchedule() {
  const selectedLocation = this.selectedLocation || 'D'; // Default to 'D' if no location is selected

  axios.get(`/getUnscheduledProduction?location=${selectedLocation}`)
    .then(response => {
      this.unscheduledOrders = response.data.map(schedule => ({
        item_no: schedule.item_no,
        partNumber: schedule.item_no,
        ord_qty: schedule.ord_qty,
        req_ship_dt: schedule.req_ship_dt || null,
        days_on_hand: schedule.days_on_hand !== null && schedule.days_on_hand !== undefined
          ? Number(schedule.days_on_hand)
          : null,
        source: schedule.source || null,
        unscheduled_bucket: schedule.unscheduled_bucket || null,

        max_inventory:
          schedule.max_inventory ?? null,

        pallet_qty:
          schedule.pallet_qty ?? null,

        max_inventory_warning:
          Boolean(schedule.max_inventory_warning),

        max_inventory_capped:
          Boolean(schedule.max_inventory_capped),

        max_inventory_partial_pallet:
          Boolean(schedule.max_inventory_partial_pallet),

        projected_inventory_after_wo:
          schedule.projected_inventory_after_wo ?? null,

        warehouse_room_before_wo:
          schedule.warehouse_room_before_wo ?? null,

        warehouse_room_after_wo:
          schedule.warehouse_room_after_wo ?? null,

        max_inventory_message:
          schedule.max_inventory_message || null,

        explanation_type: schedule.explanation_type || null,
        explanation_summary: schedule.explanation_summary || null,
        explanation_json: schedule.explanation_json || null
      }));
    //  console.log(
      //  `✅ Unscheduled production fetched for location ${selectedLocation}:`,
        //JSON.parse(JSON.stringify(this.unscheduledOrders))
      //);
    })
    .catch(error => {
      console.error(`❌ Error fetching unscheduled production for location ${selectedLocation}:`, error);
    });
},

handleSalesPlusSortChange(mode) {
  const normalized =
    String(mode || '')
      .trim()
      .toUpperCase() === 'PART_DATE'
      ? 'PART_DATE'
      : 'DATE_PART';

  if (this.salesPlusSortMode === normalized) {
    return;
  }

  this.salesPlusSortMode = normalized;

  console.log(
    '🔀 Sales+ sort changed:',
    this.salesPlusSortMode
  );

  this.fetchOutsideWindowDemand();
},


async fetchOutsideWindowDemand() {
  const selectedLocation = this.selectedLocation || 'D';

  const requestedSort =
    String(this.salesPlusSortMode || 'DATE_PART')
      .trim()
      .toUpperCase() === 'PART_DATE'
      ? 'PART_DATE'
      : 'DATE_PART';

  const requestSeq = ++this.salesPlusFetchSeq;

  console.log('📤 Sales+ REQUEST STARTED', {
    requestSeq,
    location: selectedLocation,
    sort: requestedSort
  });

  try {
    const response = await axios.get('/getOutsideWindowDemand', {
      params: {
        location: selectedLocation,
        sort: requestedSort,
        requestSeq
      }
    });

    // --------------------------------------------------
    // DEBUG 1:
    // EXACT ORDER RECEIVED FROM NODE
    // --------------------------------------------------
    console.log('🔵 PARENT RAW RESPONSE', {
      requestSeq,
      requestedSort
    });

    console.table(
      (response.data || []).slice(0, 15).map((row, index) => ({
        pos: index + 1,
        key: row.sales_plus_key,
        item: row.item_no,
        date: row.req_ship_dt,
        dateRank: row.date_part_rank,
        partRank: row.part_date_rank
      }))
    );

    // --------------------------------------------------
    // IGNORE OLD REQUESTS
    // --------------------------------------------------
    if (requestSeq !== this.salesPlusFetchSeq) {
      console.log('🗑️ IGNORING STALE SALES+ RESPONSE', {
        requestSeq,
        newestRequestSeq: this.salesPlusFetchSeq,
        requestedSort
      });

      return;
    }

    // --------------------------------------------------
    // IGNORE RESPONSE FOR OLD TOGGLE POSITION
    // --------------------------------------------------
    if (
      requestedSort !==
      String(this.salesPlusSortMode || 'DATE_PART')
        .trim()
        .toUpperCase()
    ) {
      console.log('🗑️ IGNORING RESPONSE FOR OLD SORT', {
        requestSeq,
        requestedSort,
        currentSort: this.salesPlusSortMode
      });

      return;
    }

    // --------------------------------------------------
    // MAP RESPONSE INTO PABLO'S SALES+ OBJECTS
    // --------------------------------------------------
    this.outsideWindowOrders = (response.data || []).map(row => ({
      item_no: row.item_no,
      partNumber: row.item_no,

      ord_qty: Number(
        row.ord_qty ||
        row.potential_short_qty ||
        0
      ),

      sales_plus_key: row.sales_plus_key,
      chunk_index: Number(row.chunk_index || 1),

      date_part_rank:
        row.date_part_rank != null
          ? Number(row.date_part_rank)
          : null,

      part_date_rank:
        row.part_date_rank != null
          ? Number(row.part_date_rank)
          : null,

      req_ship_dt:
        row.req_ship_dt ||
        row.earliest_req_ship_dt ||
        null,

      days_on_hand: null,

      source: row.source || 'Sales+',
      unscheduled_bucket: 'SALES_PLUS',

      demand_bucket: row.demand_bucket || null,

      qty_ordered: Number(row.qty_ordered || 0),
      qty_on_hand: Number(row.qty_on_hand || 0),
      open_wo_qty: Number(row.open_wo_qty || 0),

      sales_order_count: Number(
        row.sales_order_count || 0
      ),

      order_numbers: row.order_numbers || '',

      explanation_type:
        row.explanation_type ||
        'SALES_PLUS',

      explanation_summary:
        row.explanation_summary ||
        null,

      explanation_json:
        row.explanation_json ||
        null
    }));

    // --------------------------------------------------
    // DEBUG 2:
    // EXACT ORDER AFTER THE PARENT MAPS IT
    // --------------------------------------------------
    console.log('🟢 PARENT MAPPED ARRAY', {
      requestSeq,
      requestedSort
    });

    console.table(
      this.outsideWindowOrders.slice(0, 15).map((row, index) => ({
        pos: index + 1,
        key: row.sales_plus_key,
        item: row.item_no,
        date: row.req_ship_dt,
        dateRank: row.date_part_rank,
        partRank: row.part_date_rank
      }))
    );

    console.log('✅ SALES+ RESPONSE ACCEPTED', {
      requestSeq,
      sort: requestedSort,
      rows: this.outsideWindowOrders.length
    });

  } catch (error) {
    if (requestSeq !== this.salesPlusFetchSeq) {
      console.log(
        '🗑️ Ignoring stale Sales+ request error:',
        requestSeq
      );

      return;
    }

    console.error(
      `❌ Error fetching outside-window demand for location ${selectedLocation}:`,
      error
    );

    this.outsideWindowOrders = [];
  }
},

async refreshEngineAndReload(source = 'manual') {
  if (this.isPlanning || this.isRefreshing) return;

  const location = this.selectedLocation || 'D';
  const planningDays = this.planningDays;
  const forecastMultiplier = 1;

  console.log(
    `🔄 [Refresh] source=${source}`,
    {
      location,
      planningDays,
      forecastMultiplier
    }
  );

  this.isRefreshing = true;

  try {

    // --------------------------------------------------
    // 1. RUN PABLO ENGINE
    // --------------------------------------------------
    await axios.get('/run-feature-eng-fg', {
      params: {
        location,
        planningDays,
        forecastMultiplier,
        machineItemLimits:
          JSON.stringify(this.machineItemLimits)
      }
    });


    // --------------------------------------------------
    // 2. FETCH PABLO'S FINISHED SCHEDULE / SEQUENCE
    // --------------------------------------------------
    await Promise.all([
      this.fetchCurrentSchedule(),
      this.fetchProductionSchedule(),
      this.fetchOutsideWindowDemand(),
      this.fetchUnscheduledForecasts(),
      this.fetchMaterialAlerts(),
      this.fetchMachineNotes()
    ]);


    // --------------------------------------------------
    // 3. LAST SCHEDULE OPERATION:
    //    FILL RUN 1-7 USING THE FINISHED SEQUENCE
    // --------------------------------------------------
    await this.fillLockedMachineRunsAfterRefresh();


    // IMPORTANT:
    // NO fetchCurrentSchedule() after Fill Runs.

    console.log('[Refresh] done');

  } catch (err) {
    console.error('[Refresh] failed:', err);

  } finally {
    this.isRefreshing = false;
  }
},


//the next two call are for showing unscheduled production needs on existing work orders
showForecastDetails(itemNo) {
  axios.get('/getUnscheduledForecast', {
    params: { item_no: itemNo, location: this.selectedLocation }
  })
  .then(response => {
    this.forecastDetails = response.data;
    this.showForecastPopup = true;
  })
  .catch(error => {
    console.error('No forecast found for item:', itemNo, error.response?.data || error.message);
  });
},

fetchUnscheduledForecasts() {
  axios.get('/getUnscheduledExisting', {
    params: { location: this.selectedLocation }
  })
  .then(response => {
    this.unscheduledForecasts = response.data;
    //console.log('Forecasts loaded:', JSON.parse(JSON.stringify(this.unscheduledForecasts)));
  })
  .catch(error => {
    console.error('Error fetching unscheduled forecasts:', error);
  });
},



    fetchMaterialAlerts() {
  const loc = (this.selectedLocation || 'D').toUpperCase(); // default to D if needed

  axios.get('/getInsufficientMaterials', {
    params: { location: loc }
  })
    .then(response => {
      this.materialAlerts = response.data.map(alert => ({
        item_no: alert.item_no,
        insufficiency: alert.qty_needed
        // work_ord_no and component_item_no are not in the current JSON,
        // so we'd leave them out (or set to null if you really want them).
      }));
      //console.log('Material alerts fetched:', JSON.parse(JSON.stringify(this.materialAlerts)));
    })
    .catch(error => {
      console.error('Error fetching material alerts:', error);
    });
},


    formatQty(num) {
      if (num == null || num === '') return '';
      const value = Number(num);
      if (!Number.isFinite(value)) return '';
      return Math.round(value).toString();
    },

fetchInsufficiencyDetails(item_no, ord_no = null) {
  const loc = (this.selectedLocation || 'D')
    .trim()
    .toUpperCase();

  const params = {
    location: loc,
    item_no
  };

  if (ord_no) {
    params.ord_no = ord_no;
  }

  axios.get('/getInsufficiencyDetails', {
    params
  })
    
    .then(response => {
      console.log(
        'RAW /getInsufficiencyDetails response:',
        response.data
      );

      this.insufficiencyDetails = (
        Array.isArray(response.data)
          ? response.data
          : []
      ).map(detail => ({
        item_no:
          String(detail.item_no || '').trim(),

        component_item_no:
          String(
            detail.component_item_no ??
            detail.item_no_bom ??
            ''
          ).trim(),

        qty_needed:
          detail.qty_needed === null ||
          detail.qty_needed === undefined ||
          detail.qty_needed === ''
            ? null
            : Number(detail.qty_needed),

        qty_on_hand:
          detail.qty_on_hand === null ||
          detail.qty_on_hand === undefined ||
          detail.qty_on_hand === ''
            ? null
            : Number(detail.qty_on_hand),

        shortage:
          detail.shortage === null ||
          detail.shortage === undefined ||
          detail.shortage === ''
            ? null
            : Number(detail.shortage),

        cumulative_shortage:
          detail.cumulative_shortage === null ||
          detail.cumulative_shortage === undefined ||
          detail.cumulative_shortage === ''
            ? null
            : Number(detail.cumulative_shortage),

        shortage_label:
          String(detail.shortage_label || '').trim(),

        component_type:
          String(detail.component_type || '').trim()
      }));

      console.log(
        'MAPPED insufficiencyDetails:',
        this.insufficiencyDetails
      );

      this.showPopup = true;
    })
    .catch(error => {
      console.error(
        'Error fetching insufficiency details:',
        error.response?.data || error
      );

      this.insufficiencyDetails = [];
    });
},

showInsufficiencyDetails(payload) {
  const itemNo =
    typeof payload === 'object'
      ? payload.item_no
      : payload;

  const ordNo =
    typeof payload === 'object'
      ? payload.ord_no
      : null;

  this.fetchInsufficiencyDetails(
    itemNo,
    ordNo
  );
},

async fillLockedMachineRunsAfterRefresh() {
  const loc = String(this.selectedLocation || "D")
    .trim()
    .toUpperCase()
    .slice(0, 1);

  const lockedMachines = (this.machines || []).filter(
    machine =>
      machine &&
      machine.name &&
      machine.locked &&
      Array.isArray(machine.orders) &&
      machine.orders.length > 0
  );

  if (!lockedMachines.length) {
    console.log("🧠 No locked machines to auto-fill.");
    return;
  }

  console.log(
    "🧠 Auto-filling RUN quantities for locked machines:",
    lockedMachines.map(m => m.name)
  );

  const failures = [];

  /*
    Run these sequentially rather than hammering the backend
    with every machine simultaneously.
  */
  for (const machine of lockedMachines) {
    try {
      const res = await axios.post("/fillMachineRuns", {
        loc,
        machine: machine.name,
        planningDays: this.planningDays
      });

      const plan = Array.isArray(res.data?.plan)
        ? res.data.plan
        : [];

      /*
        IMPORTANT:
        Do NOT fetchCurrentSchedule() here.

        /fillMachineRuns returns the finished RUN values,
        so apply them directly to the orders already displayed
        in the GUI.
      */
      const planByOrdNo = new Map(
        plan.map(row => [
          String(row.ord_no),
          row
        ])
      );

      for (const order of machine.orders || []) {
        const ordNo = String(
          order.orderId ??
          order.ord_no ??
          ""
        );

        const filledRow = planByOrdNo.get(ordNo);

        if (!filledRow) continue;

        for (let day = 1; day <= 7; day++) {
          order[`RUN ${day}`] =
            Number(filledRow[`RUN ${day}`]) || 0;
        }
      }

      console.log(
        `✅ Auto-filled RUN quantities for ${machine.name}`,
        res.data
      );

    } catch (err) {
      const message =
        err.response?.data?.error ||
        err.message ||
        "Unknown Fill Runs error";

      console.error(
        `❌ Auto Fill Runs failed for ${machine.name}:`,
        err.response?.data || err
      );

      failures.push({
        machine: machine.name,
        message
      });
    }
  }

  // Force Vue to redraw the changed RUN values.
  this.machines = [...this.machines];

  if (failures.length) {
    alert(
      "Pablo refreshed, but Fill Runs failed for:\n\n" +
      failures
        .map(f => `${f.machine}: ${f.message}`)
        .join("\n")
    );
  }
},

async fillMachineRuns(machine) {
  try {
    if (!machine || !machine.name) {
      alert("Missing machine.");
      return;
    }

    if (!machine.locked) {
      alert("Lock this machine before filling run quantities.");
      return;
    }

    const loc = String(this.selectedLocation || "D")
      .trim()
      .toUpperCase()
      .slice(0, 1);

    console.log("🧠 Filling machine runs:", {
      loc,
      machine: machine.name,
      planningDays: this.planningDays
    });

    const res = await axios.post("/fillMachineRuns", {
      loc,
      machine: machine.name,
      planningDays: this.planningDays
    });

    console.log("✅ Fill Runs result:", res.data);

    await this.fetchCurrentSchedule();

    // Optional: open the capacity modal after fill so they can verify utilization.
    // If this feels annoying, remove these two lines later.
    await this.openMachineLoadModal({ machineName: machine.name });

  } catch (err) {
    console.error("❌ fillMachineRuns failed:", err);

    alert(
      err.response?.data?.error ||
      "Could not fill run quantities for this machine."
    );
  }
},

// Method to trigger "Plan It Pablo"
    async planItPablo() {
      //console.log('[PlanIt] Button clicked');


      if (this.isPlanning) return;

      const loc = String(this.selectedLocation || '').trim().toUpperCase().slice(0, 1);
      const planningDays = this.planningDays;
      const forecastMultiplier = 1;

      //console.log('[PlanIt] Payload prepared:', {
        //loc,
        //planningDays,
        //forecastMultiplier
      //});

      this.isPlanning = true;
      console.log(' [PlanIt] isPlanning set to true');

      try {
        console.log('[PlanIt] Sending POST /plan-it-pablo');   

        await axios.post('/plan-it-pablo', {
          loc,
          planningDays,
          forecastMultiplier
        });

        

        // refresh the screen (same pattern you already use)
        this.fetchCurrentSchedule();
        this.fetchProductionSchedule();
        this.fetchOutsideWindowDemand();
        this.fetchUnscheduledForecasts();
        this.fetchMaterialAlerts();

      } catch (err) {
          const status = err?.response?.status;
          const data = err?.response?.data;

          // Log the useful part
          console.error('❌ Plan It Pablo failed:', status, data || err);

          // ✅ Intended guardrail case
          if (status === 409) {
            alert(data?.message || 'You have pending work orders. Please commit or delete them, refresh, and then ask Pablo (nicely) again.');
            return;
          }

          alert('Plan It Pablo failed — check console for details.');
        } finally {
          this.isPlanning = false;
        }

    },


    closePopup() {
      this.showPopup = false;
    },

//    showInsufficiencyDetails(ord_no) {
  //    this.fetchInsufficiencyDetails(ord_no);
    //},

//    runFeatureEngFG() {
//  const location = this.selectedLocation;
//  const planningDays = this.planningDays;           // ← from your dropdown
//  const forecastMultiplier = 1;                      // or bind this to a UI control later

  //console.log(`Running feature_engFG.py for location: ${location}, days: ${planningDays}, mult: ${forecastMultiplier}`);

//  axios.get('/run-feature-eng-fg', {
  //  params: {
    //  location,
      //planningDays,
//      forecastMultiplier,
  //    machineItemLimits: JSON.stringify(this.machineItemLimits)
//    }
 // })

//  .then(response => {
  //  console.log("file executed", response.data);
    // After generating new CSVs, pull fresh data:
    //this.fetchCurrentSchedule();
 //   this.fetchProductionSchedule();
   // this.fetchUnscheduledForecasts();
 //   this.fetchMaterialAlerts();
 // })
 // .catch(error => {
 //   console.error("❌ Error running feature_engFG.py:", error);
  //});
//}
//},

async runFeatureEngFG(source = 'manual') {
  return this.refreshEngineAndReload(source);
 }
},

    
    
    // Method to close the "Pablo has planned it!" popup
    closePlanItPopup() {
      this.showPlanItPopup = false;
    },

    displayOldWorkOrders(oldWorkOrders) {
      //console.log('Displaying old work orders:', oldWorkOrders);
      this.oldWorkOrders = oldWorkOrders;
    },
  

  mounted() {

    //console.log('planItPablo type:', typeof this.planItPablo);

    this.checkConnectionHealth();
    this.fetchThroughputData();
    this.fetchMachines();
    this.fetchProductionSchedule();
    this.fetchOutsideWindowDemand();
    this.fetchMaterialAlerts();
    this.runFeatureEngFG();
    this.fetchMaterialAlerts();
    this.fetchMachineNotes();
    this.fetchPlanNotes();
    this.fetchWorkOrderStatuses();
    this.fetchMachineResources();
    
    
  }
};
</script>

<style scoped>
.jim-scheduling-container {
  font-family: Garamond, serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 20px;
}

.left-side-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
  color: #fff;
  
}

.jim-scheduling-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #0b0101;
}

.main-content {
  display: flex;
  width: 100%;
  margin-top: 20px;
  gap: 10px;              /* space between the two columns */
  align-items: flex-start;
}

.machines-section {
  flex: 3 1 0;            /* takes about 75% of the row */
  min-width: 0;           /* IMPORTANT: lets it shrink inside flex */
}

.unscheduled-section {
  flex: 1 1 0;            /* takes about 25% of the row */
  /* remove big left margin, gap handles spacing */
  margin-left: 0;
}


.machines {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background-color: #0b0101;
  padding: 10px 20px;
  border-radius: 8px;
  text-align: center;
  max-width: 95vw;
  max-height: 90vh;
  overflow: auto;
  border: 1px solid #888;
  color: #cbbfbf;
}

.page-heading {
  font-family: 'Cormorant Garamond', serif;
  font-size: 36px;
  color: #cbbfbf;
  margin-bottom: 20px;
}

.page-header-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
}

.page-header-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 16px;
}



.connection-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 11px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  border: 1px solid transparent;
}

.connection-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
}

.connection-good {
  color: #b7d7b7;
  background: rgba(36, 115, 36, 0.18);
  border-color: rgba(90, 160, 90, 0.35);
}

.connection-good .connection-dot {
  background: #6fbf73;
}

.connection-bad {
  color: #ffd6d6;
  background: rgba(160, 35, 35, 0.32);
  border-color: rgba(255, 100, 100, 0.65);
}

.connection-bad .connection-dot {
  background: #ff5c5c;
  box-shadow: 0 0 8px rgba(255, 92, 92, 0.8);
}

.connection-bad .connection-text {
  font-weight: 700;
}

.modal {
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: white;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 300px;
  text-align: center;
}

.pending-popup-content {
  background-color: #0b0101;
  padding: 10px 20px;
  border-radius: 8px;
  text-align: center;
  max-width: 95vw;
  max-height: 90vh;
  overflow: auto;
  border: 1px solid #888;
  color: #cbbfbf;
}


button {
  margin-top: 20px;
}

.pending-btn {
  border-radius: 10px;
  margin-bottom: 20px;
  margin-left: 10px;
  margin-top: 10px;
}

.modal-shortage-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 22px;
  min-width: 22px;
  height: 22px;
  margin-right: 6px;

  border: 1px solid #fca5a5;
  border-radius: 50%;

  background-color: #5b1111;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 800;
  line-height: 1;
}

.modal-shortage-indicator-wide {
  width: 30px;
  min-width: 30px;
  border-radius: 999px;
  font-size: 0.68rem;
}

/* 🔹 Pablo-the-Elder style modal overlay */
.shortage-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);  /* match .popup-overlay */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}

/* 🔹 Dark Pablo panel (like pending-popup-content) */
.shortage-modal {
  background-color: #0b0101;
  color: #cbbfbf;
  padding: 10px 20px;
  border-radius: 8px;
  max-width: 900px;
  width: 95vw;
  max-height: 130vh;
  overflow: auto;
  border: 1px solid #888;
  font-family: Garamond, serif;
}

/* Header bar + close button */
.shortage-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid #444;
  padding-bottom: 0.5rem;
}

.shortage-modal-header h3 {
  margin: 0;
  font-family: 'Cormorant Garamond', Garamond, serif;
  font-size: 22px;
  color: #cbbfbf;
}

/* Table styling inside dark modal */
.shortage-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.5rem;
  font-size: 0.85rem;
}

.shortage-table th,
.shortage-table td {
  border: 1px solid #333;
  padding: 0.25rem 0.4rem;
  text-align: left;
}

.shortage-table th {
  background-color: #1f2933;
  color: #e5e7eb;
}

.shortage-table td {
  background-color: #111827;
  color: #e5e7eb;
}

/* Close button in the corner */
.close-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 1.1rem;
  color: #cbbfbf;
}

.close-btn:hover {
  color: #ffffff;
}

.popup-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.75rem;
  font-size: 0.95rem;
}

.popup-table th,
.popup-table td {
  border: 1px solid #333;
  padding: 0.35rem 0.55rem;
  text-align: left;
}

.popup-table th {
  background-color: #1f2933;
  color: #e5e7eb;
}

.popup-table td {
  background-color: #111827;
  color: #e5e7eb;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid #444;
  padding-bottom: 0.5rem;
}

.popup-header h3 {
  margin: 0;
  font-family: 'Cormorant Garamond', Garamond, serif;
  font-size: 24px;
  color: #cbbfbf;
}

.notes-textarea {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  border-radius: 8px;   /* rounded corners */
  padding: 12px;

  min-height: 120px;     /* make it feel like a real notes box */
  resize: vertical;      /* allow resize if you want */
}

.standing-note-inline {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.2;
  color: #ffd966;
  white-space: normal;
}

.standing-note-inline strong {
  color: #fff2cc;
}

.plan-it-btn {
  border-radius: 10px;
  padding: 8px 16px;
  margin-left: 10px;
  width: 125px;

  background-color: #f3f4f6;   /* light neutral */
  border: 1px solid #cfd3d8;
  color: #333;

  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.plan-it-btn:hover:not(:disabled) {
  background-color: #e5e7eb;
  border-color: #bfc5cc;
}

.plan-it-btn:disabled {
  background-color: #e5e7eb;
  color: #888;
  cursor: not-allowed;
}

.planning-window label {
  color: inherit;
  font-weight: 600;
  margin-top: 20px;
}

.planning-window select {
  color: inherit;
  background-color: #111;      /* subtle contrast on black */
  border: 1px solid #444;
  margin-top: 10px;;
}

.shortage-input {
  width: 100%;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid rgba(0,0,0,0.15);
}
.planning-window {
  padding-top: 60px; /* adjust once and forget */
}

.plan-notes-textarea {
  min-height: 90px;
  font-size: 15px;
  line-height: 1.25;
}

.small-muted {
  font-size: 0.85rem;
  color: #aeb6c2;
}

/* Wider Machine Notes modal */
.machine-notes-modal {
  width: 98vw;
  max-width: 1400px;
}

/* Preserve one-line primary work-order rows */
.machine-notes-table-wrap {
  width: 100%;
  max-height: 52vh;

  overflow-y: auto;
  overflow-x: auto;

  border: 1px solid #333;
}

.machine-notes-table {
  width: 100%;
  min-width: 1050px;
  border-collapse: collapse;
}

.machine-notes-table thead th {
  position: sticky;
  top: 0;
  z-index: 5;

  background-color: #1f2933;
}

.machine-notes-table th,
.machine-note-main-row td {
  height: 32px;
  padding: 3px 5px !important;
  line-height: 1.1;
  white-space: nowrap;
  vertical-align: middle;
}

.machine-notes-table .wo-note-input {
  height: 24px;
  min-width: 210px;
  padding: 2px 5px;
  box-sizing: border-box;
}

.machine-notes-table .wo-status-select {
  height: 26px;
  min-width: 130px;
  padding: 1px 4px;
  box-sizing: border-box;
}

.shortage-toggle-heading,
.shortage-toggle-cell {
  width: 90px;
  min-width: 90px;
  text-align: center !important;
}

.shortage-toggle-heading,
.shortage-toggle-cell {
  width: 22px;
  min-width: 22px;
  padding-left: 2px !important;
  padding-right: 2px !important;
  text-align: center !important;
}

.shortage-expand-btn {
  width: 14px;
  height: 14px;
  padding: 0;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border: 1px solid #777;
  border-radius: 3px;

  background-color: #1f2933;
  color: #ffffff;

  font-size: 11px;
  font-weight: 700;
  line-height: 1;

  cursor: pointer;
}

.shortage-expand-btn:hover {
  background-color: #374151;
  border-color: #cccccc;
}

.no-shortage-symbol {
  color: #6b7280;
  font-size: 0.8rem;
}

.shortage-toggle-btn:hover {
  filter: brightness(1.12);
}

.no-shortage-symbol {
  color: #6b7280;
}

/* Expanded area under the main work-order row */
.nested-shortage-row > td {
  padding: 0 !important;
  background-color: #0d131a !important;
}

.nested-shortage-panel {
  padding: 7px 10px 9px 38px;
  border-left: 3px solid #777;
  border-bottom: 1px solid #374151;
}

.nested-shortage-heading {
  margin-bottom: 8px;
  color: #e5e7eb;
  font-size: 0.82rem;
}

.nested-shortage-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

.nested-shortage-table th,
.nested-shortage-table td {
  padding: 3px 6px;
  border: 1px solid #374151;
  white-space: nowrap;
  text-align: left;
}

.nested-shortage-table th {
  background-color: #1f2933;
  color: #e5e7eb;
}

.nested-shortage-table td {
  background-color: #111827;
  color: #e5e7eb;
}

.nested-shortage-quantity {
  color: #ffb4b4 !important;
  font-weight: 800;
}

.nested-shortage-message {
  padding: 8px;
  color: #cbd5e1;
  font-style: italic;
}

.nested-shortage-error {
  padding: 8px;
  color: #ff7b7b;
  font-weight: 700;
}







</style>
